import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import {
  Box,
  Typography,
  Tooltip,
  Paper,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  TextField,
  InputAdornment,
  IconButton,
  Pagination,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Autocomplete, // Added import
  Button,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  Chip,
  Menu,
  ListItemButton,
  Divider,
  Badge,
  Avatar,
  Checkbox,
  TableContainer,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Modal
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from "@mui/icons-material/Add";
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import SettingsIcon from '@mui/icons-material/Settings';
import LinkIcon from '@mui/icons-material/Link';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ScienceIcon from '@mui/icons-material/Science';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CodeIcon from '@mui/icons-material/Code';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import MonitorIcon from '@mui/icons-material/Monitor';
import SecurityIcon from '@mui/icons-material/Security';
import SendIcon from '@mui/icons-material/Send';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FilterListIcon from '@mui/icons-material/FilterList';
import SortIcon from '@mui/icons-material/Sort';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ImageIcon from '@mui/icons-material/Image';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import ListIcon from '@mui/icons-material/List';
import FavoriteIcon from '@mui/icons-material/Favorite';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DateRangeIcon from '@mui/icons-material/DateRange';
import PeopleIcon from '@mui/icons-material/People';
import MouseIcon from '@mui/icons-material/Mouse';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CpuIcon from '@mui/icons-material/Memory';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import { debounce } from 'lodash';
import prettier from 'prettier/standalone';
import * as parserHtml from 'prettier/parser-html';
import { api } from '../../services/auth';
import { getEmailGlobalStats, analyzeEmailPerformance } from '../../services/chatService';
// HIDE_INCOMPLETE_FEATURES removed: Analyse & IA is now fully enabled
import { useNavigate } from 'react-router-dom';
import EmailAssistant from '../../components/EmailAssistantNew';
import { getArchives, addArchive, removeArchive } from '../../services/archiveService';
import { getFavorites, addFavorite, removeFavorite } from '../../services/favoriteService';
import { useNotification } from '../../contexts/NotificationContext';
import Header from '../../components/Header';
import CloseIcon from '@mui/icons-material/Close'; // Added import
import CheckIcon from '@mui/icons-material/Check'; // Added import
import BugReportIcon from '@mui/icons-material/BugReport';
import Collapse from '@mui/material/Collapse';
import spamServices from '../../services/spamservices';
import Joyride, { STATUS, EVENTS } from 'react-joyride';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

// Removed direct Unomi access - now using backend API

// getUserConfig() removed - user brand is now handled by backend authentication

const getCampaignStatus = (campaign) => {
  const now = new Date();
  const publishUp = campaign.publishUp ? new Date(campaign.publishUp) : null;
  const publishDown = campaign.publishDown ? new Date(campaign.publishDown) : null;

  if (!campaign.isPublished) {
    return { label: 'Brouillon', bgColor: '#FEF3C7', color: '#92400E' }; // Orange
  }

  if (publishUp && publishUp > now) {
    return { label: 'Programmé', bgColor: '#D1E9FF', color: '#1E40AF' }; // Blue
  }

  if (publishDown && publishDown < now) {
    return { label: 'Terminé', bgColor: '#F3F4F6', color: '#4B5563' }; // Gray
  }

  return { label: 'En cours', bgColor: '#D1FAE5', color: '#065F46' }; // Green
};

const Emails = () => {
  // Helper function to get the correct tab index accounting for hidden tabs
  const getTabIndex = (targetTab) => {
    const tabs = [ 
      'Analyse & IA', 
      'Contacts', 
      'Performance des Clics', 
      'A/B Test', 
      'Configuration' 
    ];
    return tabs.indexOf(targetTab);
  };

  const handleRetryEditorState = async () => {
    if (!selectedEmailDetails || !selectedEmailDetails.id) return;

    setEditorStateLoading(true);
    setEditorStateError(null);
    setInitialMjml(null);
    setInitialBuilderJson(null);
    setInitialLastMode(null);
    setInitialHtmlEdited(false);
    setInitialHtmlSnapshot(null);
    setInitialDynamicContent(null);

    try {
      const response = await api.get(`/emails/${selectedEmailDetails.id}/state`);
      if (response.data && response.data.success && response.data.state) {
        const state = response.data.state;
        setInitialMjml(state.mjml || null);
        setInitialBuilderJson(state.builderJson || null);
        setInitialLastMode(state.last_mode || null);
        setInitialHtmlEdited(Boolean(state.html_edited));
        setInitialHtmlSnapshot(state.html_snapshot || null);
        setInitialDynamicContent(state.dynamicContent || null);
      } else {
        setEditorStateError(response.data?.message || "Impossible de charger l'état de l'éditeur.");
      }
    } catch (err) {
      console.error('[EMAILS] Erreur chargement état éditeur:', err);
      const msg = err?.response?.data?.message || err.message || "Erreur lors du chargement de l'état de l'éditeur.";
      setEditorStateError(msg);
    } finally {
      setEditorStateLoading(false);
    }
  };

  const handleOpenAssistantEdit = () => {
    if (!selectedEmailDetails || !selectedEmailDetails.id) return;

    setAssistantMode('edit');
    setInterfaceHidden(true);

    // Ouvrir d'abord la modale, puis charger l'état éditeur en arrière-plan
    setAssistantOpen(true);

    handleRetryEditorState();
  };
  const navigate = useNavigate();
  const [emails, setEmails] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [onGoingAbTests, setOnGoingAbTests] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const { showNotification } = useNotification();
  const [actionInProgress, setActionInProgress] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [renameModalOpen, setRenameModalOpen] = useState(false);
  const [emailToClone, setEmailToClone] = useState(null);
  const [newName, setNewName] = useState('');
  const [isCloning, setIsCloning] = useState(false);
  const [htmlModalOpen, setHtmlModalOpen] = useState(false);
  const [formattedHtml, setFormattedHtml] = useState('');
  const [copied, setCopied] = useState(false);
  const [textModalOpen, setTextModalOpen] = useState(false);
  const [textContent, setTextContent] = useState('');
  const [textCopied, setTextCopied] = useState(false);
  const [mailPreviewModalOpen, setMailPreviewModalOpen] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [previewError, setPreviewError] = useState(null);
  const [testId, setTestId] = useState(null);
  const [previewResults, setPreviewResults] = useState([]);
  const [isPolling, setIsPolling] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  const [spamModalOpen, setSpamModalOpen] = useState(false);
  const [spamFormData, setSpamFormData] = useState({ from: '', to: '', subject: '' });
  const [spamReport, setSpamReport] = useState(null);
  const [isSpamReportLoading, setIsSpamReportLoading] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [spamError, setSpamError] = useState(null);
  const [openSection, setOpenSection] = useState(null);

  // State for the improved Test Email Modal
  const [testEmailModalOpen, setTestEmailModalOpen] = useState(false);
  const [testRecipients, setTestRecipients] = useState([]);
  const [recipientInput, setRecipientInput] = useState('');
  const [testSubject, setTestSubject] = useState('');
  const [isSendingTest, setIsSendingTest] = useState(false);
  const [abTestData, setAbTestData] = useState(null);
  const [abTestLoading, setAbTestLoading] = useState(false);
  const [abTestError, setAbTestError] = useState(null);
  const abTestControllerRef = React.useRef(null);
  const [testEmailError, setTestEmailError] = useState(null);
  const [testEmailSuccess, setTestEmailSuccess] = useState(false);
  const [contactOptions, setContactOptions] = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [archivedEmails, setArchivedEmails] = useState([]);
  const [favoritesEmails, setFavoritesEmails] = useState([]);
  const [contactInput, setContactInput] = useState('');
  
  // États pour l'onglet Analyse & IA
  const [emailStats, setEmailStats] = useState(null);
  const [emailStatsLoading, setEmailStatsLoading] = useState(false);
  const [emailStatsError, setEmailStatsError] = useState(null);
  const [emailAnalysis, setEmailAnalysis] = useState(null);
  const [emailAnalysisLoading, setEmailAnalysisLoading] = useState(false);
  const [emailAnalysisError, setEmailAnalysisError] = useState(null);
  const emailAnalysisAbortController = useRef(null);
  
  // Email Assistant states
  const [assistantOpen, setAssistantOpen] = useState(false);
  const [assistantMode, setAssistantMode] = useState('new');
  const [interfaceHidden, setInterfaceHidden] = useState(false);
  const [initialMjml, setInitialMjml] = useState(null);
  const [initialBuilderJson, setInitialBuilderJson] = useState(null);
  const [initialLastMode, setInitialLastMode] = useState(null);
  const [initialHtmlEdited, setInitialHtmlEdited] = useState(false);
  const [initialHtmlSnapshot, setInitialHtmlSnapshot] = useState(null);
  const [initialDynamicContent, setInitialDynamicContent] = useState(null);
  const [editorStateLoading, setEditorStateLoading] = useState(false);
  const [editorStateError, setEditorStateError] = useState(null);
  
  // Date filter states - Calendar with range selection
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [currentCalendarDate, setCurrentCalendarDate] = useState(() => {
    const now = new Date();
    return { year: now.getFullYear(), month: now.getMonth() + 1 };
  });
  const [selectingRange, setSelectingRange] = useState(false);
  const [monthYearPickerOpen, setMonthYearPickerOpen] = useState(false);

  // Calendar helper functions
  const generateCalendarDays = (year, month) => {
    const formatDateLocal = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    };

    const firstDay = new Date(year, month - 1, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());
    
    const days = [];
    const today = new Date();
    
    for (let i = 0; i < 42; i++) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);
      
      const dayKey = formatDateLocal(currentDate);
      const isCurrentMonth = currentDate.getMonth() === month - 1;
      const isToday = currentDate.toDateString() === today.toDateString();
      
      days.push({
        date: currentDate,
        day: currentDate.getDate(),
        isCurrentMonth,
        isToday,
        dayKey
      });
    }
    
    return days;
  };

  const handleCalendarNavigation = (direction) => {
    let { year, month } = currentCalendarDate;
    
    if (direction === 'prev') {
      if (month === 1) {
        month = 12;
        year--;
      } else {
        month--;
      }
    } else if (direction === 'next') {
      if (month === 12) {
        month = 1;
        year++;
      } else {
        month++;
      }
    }
    
    setCurrentCalendarDate({ year, month });
  };

  const isDateInRange = (date) => {
    if (!startDate || !endDate) return false;
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);
    return checkDate >= start && checkDate <= end;
  };

  const handleCalendarDateClick = (date) => {
    const clickedDate = new Date(date);
    clickedDate.setHours(0, 0, 0, 0);
    
    if (!startDate && !endDate) {
      // First click - set start date
      setStartDate(clickedDate);
      setSelectingRange(true);
    } else if (startDate && !endDate) {
      // Second click - set end date
      if (clickedDate >= startDate) {
        setEndDate(clickedDate);
      } else {
        // If clicked date is before start, swap them
        setEndDate(startDate);
        setStartDate(clickedDate);
      }
      setSelectingRange(false);
    } else {
      // Reset and start new selection
      setStartDate(clickedDate);
      setEndDate(null);
      setSelectingRange(true);
    }
  };

  const handleQuickDateSelection = (type) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    switch (type) {
      case 'today':
        setStartDate(today);
        setEndDate(today);
        break;
      case 'week':
        const startOfWeek = new Date(today);
        const dayOfWeek = today.getDay();
        startOfWeek.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1)); // Monday
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6); // Sunday
        setStartDate(startOfWeek);
        setEndDate(endOfWeek);
        break;
      case 'month':
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        setStartDate(startOfMonth);
        setEndDate(endOfMonth);
        break;
    }
    setSelectingRange(false);
  };

  const handleMonthYearChange = (year, month) => {
    setCurrentCalendarDate({ year, month });
    setMonthYearPickerOpen(false);
  };

  const handleOpenHtmlModal = async () => {
    if (selectedEmailDetails) {
      try {
        const html = selectedEmailDetails.customHtml || selectedEmailDetails.html || '';
        const formatted = await prettier.format(html, {
          parser: "html",
          plugins: [parserHtml],
        });
        setFormattedHtml(formatted);
      } catch (error) {
        console.error("Error formatting HTML:", error);
        setFormattedHtml(selectedEmailDetails.customHtml || selectedEmailDetails.html || ''); // Fallback to unformatted HTML
      }
      setHtmlModalOpen(true);
    }
  };

  const handleCloseHtmlModal = () => {
    setHtmlModalOpen(false);
    setCopied(false); // Reset copied state when modal closes
  };

  const handleCopyHtml = () => {
    navigator.clipboard.writeText(formattedHtml).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    });
  };

  const generateTextFromHtml = (html) => {
    if (!html) return '';
    
    // Créer un élément temporaire pour parser le HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Extraire le texte brut
    let text = tempDiv.textContent || tempDiv.innerText || '';
    
    // Nettoyer le texte : supprimer les espaces multiples et les sauts de ligne excessifs
    text = text.replace(/\s+/g, ' ').trim();
    text = text.replace(/\n\s*\n/g, '\n\n'); // Garder les paragraphes
    
    return text;
  };

  // Fonction pour nettoyer le contenu texte du CSS et des balises
  const cleanTextContent = (text) => {
    if (!text) return '';
    
    console.log('=== DEBUG CLEAN TEXT CONTENT ===');
    console.log('Input text length:', text.length);
    console.log('First 200 chars:', text.substring(0, 200));
    
    // Vérifier si c'est du HTML ou du texte brut avec CSS
    const isHTML = text.includes('<html') || text.includes('<!DOCTYPE');
    console.log('Is HTML:', isHTML);
    
    if (isHTML) {
      // Si c'est du HTML, utiliser la fonction existante
      console.log('Using generateTextFromHtml');
      const result = generateTextFromHtml(text);
      console.log('HTML conversion result:', result.substring(0, 200));
      return result;
    }
    
    // Si c'est du texte brut avec CSS mélangé, approche différente
    console.log('Processing as text with embedded CSS');
    
    // Diviser le texte en segments basés sur les accolades
    const segments = [];
    let currentSegment = '';
    let braceLevel = 0;
    let inCSS = false;
    
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      
      if (char === '{') {
        if (braceLevel === 0) {
          // Début d'un bloc CSS, sauvegarder le segment précédent
          if (currentSegment.trim()) {
            segments.push({ type: 'text', content: currentSegment.trim() });
          }
          currentSegment = '';
          inCSS = true;
        }
        braceLevel++;
      } else if (char === '}') {
        braceLevel--;
        if (braceLevel === 0) {
          // Fin du bloc CSS
          inCSS = false;
          currentSegment = '';
        }
      } else if (!inCSS) {
        currentSegment += char;
      }
    }
    
    // Ajouter le dernier segment
    if (currentSegment.trim() && !inCSS) {
      segments.push({ type: 'text', content: currentSegment.trim() });
    }
    
    console.log('Segments found:', segments.length);
    segments.forEach((seg, i) => {
      console.log(`Segment ${i}:`, seg.content.substring(0, 100));
    });
    
    console.log('Raw segments before cleaning:');
    segments.filter(seg => seg.type === 'text').forEach((seg, i) => {
      console.log(`Raw segment ${i}:`, JSON.stringify(seg.content.substring(0, 50)));
    });
    
    // Filtrer et nettoyer les segments de texte
    const cleanSegments = segments
      .filter(seg => seg.type === 'text')
      .map(seg => {
        let content = seg.content;
        
        // Supprimer les sélecteurs CSS orphelins seulement s'ils sont isolés ou suivis de virgule/accolade
        content = content.replace(/\b(body|table|td|img|div|span|h[1-6])\s*[,{]/g, ' ');
        content = content.replace(/\b(body|table|td|img|div|span|h[1-6])\s*,\s*/g, ' ');
        // Supprimer 'a' et 'p' seulement quand c'est un sélecteur CSS (suivi d'une virgule ou d'un espace puis accolade)
        content = content.replace(/\b[ap]\s*[,{]/g, ' ');
        content = content.replace(/\b[ap]\s*,\s*/g, ' ');
        
        // Supprimer les propriétés CSS isolées
        content = content.replace(/[a-zA-Z-]+\s*:\s*[^;!]+[;!]/g, ' ');
        
        // Supprimer les classes et IDs
        content = content.replace(/[.#][\w-]+/g, ' ');
        
        // Nettoyer les espaces
        content = content.replace(/\s+/g, ' ').trim();
        
        return content;
      })
      .filter(content => {
        if (content.length === 0) return false;
        
        // Filtrer les segments qui sont uniquement du CSS
        if (content.match(/^@media/)) return false;
        if (content.match(/^(body|table|td|img|div|span|h[1-6])\s*,?\s*$/)) return false;
        if (content.match(/^\s*[ap]\s*,?\s*$/)) return false; // Supprimer 'a' et 'p' isolés seulement
        if (content.match(/^\.[\w-]+(\s*,\s*\.[\w-]+)*\s*$/)) return false;
        if (content.match(/^#[\w-]+(\s*,\s*#[\w-]+)*\s*$/)) return false;
        if (content.match(/^\s*(webkit|moz|ms|o)-[\w-]+\s*$/)) return false;
        if (content.match(/^\s*(only|screen|and|max-width|min-width|yahoo)\s*$/)) return false;
        
        return true;
      });
    
    let result = cleanSegments.join(' ').replace(/\s+/g, ' ').trim();
    
    // Supprimer le 'a' parasite qui apparaît avant "Si cet email ne s'affiche pas correctement"
    result = result.replace(/\ba\s+Si cet email ne s'affiche pas correctement/g, 'Si cet email ne \'affiche pas correctement');
    console.log('Final result length:', result.length);
    console.log('Final result preview:', result.substring(0, 200));
    console.log('=== END DEBUG ===');
    
    return result;
  };

  const handleOpenTextModal = () => {
    if (selectedEmailDetails) {
      let textVersion = selectedEmailDetails.plainText || 
                       selectedEmailDetails.textVersion || 
                       selectedEmailDetails.text || 
                       selectedEmailDetails.textContent ||
                       selectedEmailDetails.content ||
                       '';
      
      // Nettoyer le contenu texte du CSS
      if (textVersion) {
        textVersion = cleanTextContent(textVersion);
      }
      
      // Si aucune version texte n'est disponible, générer depuis le HTML
      if (!textVersion) {
        const htmlContent = selectedEmailDetails.customHtml || selectedEmailDetails.html || '';
        if (htmlContent) {
          textVersion = generateTextFromHtml(htmlContent);
          console.log('Version texte générée automatiquement depuis le HTML');
          // Nettoyer aussi le contenu généré depuis le HTML
          textVersion = cleanTextContent(textVersion);
        }
      }
      
      // Si toujours pas de contenu, afficher un message informatif
      if (!textVersion) {
        textVersion = 'Aucune version texte disponible pour ce template.\n\nCe template ne contient ni version texte prédéfinie ni contenu HTML à convertir.';
      }
      
      setTextContent(textVersion);
      setTextModalOpen(true);
    }
  };

  const handleCloseTextModal = () => {
    setTextModalOpen(false);
    setTextCopied(false); // Reset copied state when modal closes
  };

  const handleCopyText = () => {
    navigator.clipboard.writeText(textContent).then(() => {
      setTextCopied(true);
      setTimeout(() => setTextCopied(false), 2000); // Reset after 2 seconds
    });
  };

  // Fonctions pour la prévisualisation multi-clients
  const openMailPreviewModal = () => {
    setMailPreviewModalOpen(true);
    sendForPreview(); // Lancer le test de prévisualisation
  };

  const sendForPreview = async () => {
    setIsPreviewLoading(true);
    setPreviewError(null);
    setTestId(null);
    setPreviewResults([]);

    try {
      const response = await api.post('/emails/send-preview', {
        subject: selectedEmailDetails.name || 'Email Preview',
        html: selectedEmailDetails.customHtml || selectedEmailDetails.html,
      });

      if (response.data.success && response.data.test_id) {
        setTestId(response.data.test_id);
        setIsPolling(true); // Commencer le polling
      } else {
        setPreviewError(response.data.message || 'Échec de soumission du test email.');
        setIsPreviewLoading(false);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Une erreur est survenue lors de la soumission du test.';
      setPreviewError(errorMessage);
      setIsPreviewLoading(false);
    }
  };

  // Polling pour récupérer les résultats de prévisualisation
  useEffect(() => {
    if (!isPolling || !testId) return;

    const interval = setInterval(async () => {
      try {
        const response = await api.get(`/emails/send-preview/${testId}/results`);
        if (response.data.success) {
          const results = response.data.results;
          setPreviewResults(results);

          // Vérifier si tous les clients ont terminé le traitement
          const allComplete = results.every(r => r.status === 'Complete' || r.status === 'Bounced');
          if (allComplete) {
            setIsPolling(false);
            setIsPreviewLoading(false);
            clearInterval(interval);
          }
        }
      } catch (error) {
        console.error('Erreur lors du polling des résultats:', error);
        setPreviewError('Échec de récupération des résultats de prévisualisation.');
        setIsPolling(false);
        setIsPreviewLoading(false);
        clearInterval(interval);
      }
    }, 5000); // Polling toutes les 5 secondes

    // Nettoyage lors du démontage du composant ou arrêt du polling
    return () => clearInterval(interval);
  }, [isPolling, testId]);
  
  // New state for final design layout
  const [selectedEmailId, setSelectedEmailId] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortBy, setSortBy] = useState('modified');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(search);
  const [actionsMenuAnchor, setActionsMenuAnchor] = useState(null);
  const [previewMode, setPreviewMode] = useState('desktop');
  const [statusMenuAnchor, setStatusMenuAnchor] = useState(null);
  const [sortMenuAnchor, setSortMenuAnchor] = useState(null);
  const [sortDirection, setSortDirection] = useState('desc');
  const [subMenuCollapsed, setSubMenuCollapsed] = useState(true);
  const [viewMode, setViewMode] = useState('desktop'); // desktop or mobile
  const [favorites, setFavorites] = useState(new Set());
  const [totalEmails, setTotalEmails] = useState(0);

  // Tour state
  const [runTour, setRunTour] = useState(false);

  const [emailContacts, setEmailContacts] = useState([]);
  const [contactsTotal, setContactsTotal] = useState(0);
  const [contactsError, setContactsError] = useState(null);

  const [contactsPage, setContactsPage] = useState(0);
  const [contactsRowsPerPage, setContactsRowsPerPage] = useState(10);

  const handleContactsChangePage = (newPage) => {
    setContactsPage(newPage);
  };

  const handleContactsChangeRowsPerPage = (event) => {
    setContactsRowsPerPage(parseInt(event.target.value, 10));
    setContactsPage(0);
  };

  // Fonction pour récupérer les contacts d'un email
  const fetchEmailContacts = useCallback(async (emailId, page = 1, pageSize = 10) => {
    if (!emailId) return;
    
    // Cancel previous contacts request if any
    if (contactsControllerRef.current) {
      try { contactsControllerRef.current.abort(); } catch (_) {}
    }
    // Cross-cancel other detail requests to avoid parallel load
    if (clickPerfControllerRef.current) {
      try { clickPerfControllerRef.current.abort(); } catch (_) {}
    }
    if (abTestControllerRef.current) {
      try { abTestControllerRef.current.abort(); } catch (_) {}
    }
    const controller = new AbortController();
    contactsControllerRef.current = controller;
    
    setContactsLoading(true);
    setContactsError(null);
    try {
      const response = await api.get(`/emails/${emailId}/contacts`, {
        params: { page, page_size: pageSize },
        signal: controller.signal
      });
      
      if (response.data.success) {
        setEmailContacts(response.data.contacts);
        setContactsTotal(response.data.total);
      } else {
        console.error('Erreur lors de la récupération des contacts:', response.data.message);
        setContactsError(response.data.message || 'Erreur lors de la récupération des contacts');
        setEmailContacts([]);
        setContactsTotal(0);
      }
    } catch (error) {
      if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
        // Request cancelled: do not override state here
      } else {
      console.error('Erreur lors de la récupération des contacts:', error);
        setContactsError(error.message || 'Erreur lors de la récupération des contacts');
      setEmailContacts([]);
      setContactsTotal(0);
      }
    } finally {
      if (!controller.signal.aborted) {
      setContactsLoading(false);
      }
    }
  }, [api]);

  // Récupérer les contacts quand l'email sélectionné change ou quand on change de page
  useEffect(() => {
    if (selectedEmailId && tabValue === getTabIndex('Contacts')) { // Onglet Contacts
      // Clear previous contacts to avoid showing stale data while loading new email contacts
      setEmailContacts([]);
      setContactsTotal(0);
      fetchEmailContacts(selectedEmailId, contactsPage + 1, contactsRowsPerPage);
    } else {
      // If leaving contacts tab or no email selected, cancel any ongoing contacts request
      if (contactsControllerRef.current) {
        try { contactsControllerRef.current.abort(); } catch (_) {}
      }
      // Also cancel other details when leaving details area
      if (!selectedEmailId) {
        if (clickPerfControllerRef.current) {
          try { clickPerfControllerRef.current.abort(); } catch (_) {}
        }
        if (abTestControllerRef.current) {
          try { abTestControllerRef.current.abort(); } catch (_) {}
        }
      }
    }
  }, [selectedEmailId, tabValue, contactsPage, contactsRowsPerPage, fetchEmailContacts]);

  const paginatedContacts = emailContacts;

  // Sidebar toggle state
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  // Contact details modal state
  const [contactDetailsOpen, setContactDetailsOpen] = useState(false);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactDetails, setContactDetails] = useState(null);
  const [contactDetailsLoading, setContactDetailsLoading] = useState(false);

  // Click performance state
  const [clickPerformanceData, setClickPerformanceData] = useState(null);
  const [clickPerformanceLoading, setClickPerformanceLoading] = useState(false);
  const [clickPerformanceError, setClickPerformanceError] = useState(null);
  const contactsControllerRef = React.useRef(null);
  const clickPerfControllerRef = React.useRef(null);

  // Fonction pour récupérer les détails d'un contact
  const fetchContactDetails = async (contactId) => {
    console.log(`[DEBUG] Début fetchContactDetails pour contact ID: ${contactId}`);
    setContactDetailsLoading(true);
    try {
      console.log(`[DEBUG] Utilisation de l'instance API avec cookies HttpOnly`);
      
      const response = await api.get(`/emails/contacts/${contactId}/details`);
      console.log(`[DEBUG] Réponse API reçue:`, response.data);
      
      if (response.data && response.data.success) {
        console.log(`[DEBUG] Succès - Définition des détails du contact`);
        setContactDetails(response.data);
      } else {
        console.error(`[ERROR] API retourne success=false:`, response.data?.message);
        showNotification(`Erreur: ${response.data?.message || 'Erreur inconnue'}`, 'error');
      }
    } catch (error) {
      console.error(`[ERROR] Exception dans fetchContactDetails:`, error);
      if (error.response) {
        console.error(`[ERROR] Réponse d'erreur:`, error.response.status, error.response.data);
        showNotification(`Erreur HTTP ${error.response.status}: ${error.response.data?.detail || error.response.statusText}`, 'error');
      } else {
        showNotification(`Erreur réseau: ${error.message}`, 'error');
      }
    } finally {
      setContactDetailsLoading(false);
      console.log(`[DEBUG] Fin fetchContactDetails`);
    }
  };

  // Fonction pour ouvrir les détails d'un contact
  const handleContactClick = (contact) => {
    if (contact.lead_id) {
      setSelectedContactId(contact.lead_id);
      setContactDetailsOpen(true);
      fetchContactDetails(contact.lead_id);
    }
  };

  // Fonction pour récupérer les statistiques globales d'un email
  const fetchEmailStats = async (emailId) => {
    if (!emailId) return;
    
    console.log(`[DEBUG] Début fetchEmailStats pour email ID: ${emailId}`);
    setEmailStatsLoading(true);
    setEmailStatsError(null);
    
    try {
      const response = await getEmailGlobalStats(emailId);
      
      if (response && response.success) {
        console.log(`[DEBUG] Statistiques récupérées avec succès:`, response.stats);
        setEmailStats(response.stats);
      } else {
        console.error(`[ERROR] Erreur lors de la récupération des statistiques:`, response?.message);
        setEmailStatsError(response?.message || 'Erreur lors de la récupération des statistiques');
      }
    } catch (error) {
      console.error(`[ERROR] Exception dans fetchEmailStats:`, error);
      setEmailStatsError(error.message || 'Erreur lors de la récupération des statistiques');
    } finally {
      setEmailStatsLoading(false);
    }
  };

  // Fonction pour lancer l'analyse IA d'un email
  const fetchEmailAnalysis = async (emailId, emailName) => {
    if (!emailId) return;
    
    console.log(`[DEBUG] Début fetchEmailAnalysis pour email ID: ${emailId} (${emailName})`);
    
    // Annuler la requête précédente si elle existe
    if (emailAnalysisAbortController.current) {
      emailAnalysisAbortController.current.abort();
    }
    
    // Créer un nouveau contrôleur d'annulation
    emailAnalysisAbortController.current = new AbortController();
    
    setEmailAnalysisLoading(true);
    setEmailAnalysisError(null);
    
    try {
      const response = await analyzeEmailPerformance(emailId, emailName, {
        signal: emailAnalysisAbortController.current.signal
      });
      
      if (response && response.success) {
        console.log(`[DEBUG] Analyse IA terminée avec succès`);
        setEmailAnalysis(response);
      } else {
        console.error(`[ERROR] Erreur lors de l'analyse IA:`, response?.message);
        setEmailAnalysisError(response?.message || 'Erreur lors de l\'analyse IA');
      }
    } catch (error) {
      // Ignorer les erreurs d'annulation
      if (error.name === 'AbortError' || error.message.includes('canceled')) {
        console.log(`[DEBUG] Analyse IA annulée`);
        return;
      }
      
      console.error(`[ERROR] Exception dans fetchEmailAnalysis:`, error);
      setEmailAnalysisError(error.message || 'Erreur lors de l\'analyse IA');
    } finally {
      setEmailAnalysisLoading(false);
    }
  };

  // Fonction pour récupérer les performances de clics d'un email
  const fetchClickPerformance = async (emailId) => {
    console.log(`[DEBUG] Début fetchClickPerformance pour email ID: ${emailId}`);
    if (clickPerfControllerRef.current) {
      try { clickPerfControllerRef.current.abort(); } catch (_) {}
    }
    // Cross-cancel other detail requests to avoid parallel load
    if (contactsControllerRef.current) {
      try { contactsControllerRef.current.abort(); } catch (_) {}
    }
    if (abTestControllerRef.current) {
      try { abTestControllerRef.current.abort(); } catch (_) {}
    }
    const controller = new AbortController();
    clickPerfControllerRef.current = controller;
    setClickPerformanceLoading(true);
    setClickPerformanceError(null);
    try {
      const response = await api.get(`/emails/emails/${emailId}/click_performance`, { signal: controller.signal });
      console.log(`[DEBUG] Réponse performance clics reçue:`, response.data);
      
      if (response.data && response.data.success) {
        console.log(`[DEBUG] Succès - Définition des données de performance`);
        setClickPerformanceData(response.data);
      } else {
        console.error(`[ERROR] API retourne success=false:`, response.data?.message);
        setClickPerformanceError(response.data?.message || 'Erreur lors de la récupération des performances de clics');
        setClickPerformanceData(null);
      }
    } catch (error) {
      const wasCancelled = error.name === 'AbortError' || error.code === 'ERR_CANCELED';
      if (wasCancelled) {
        console.log('[DEBUG] Click performance request was cancelled');
      } else {
      console.error(`[ERROR] Exception dans fetchClickPerformance:`, error);
        setClickPerformanceError(error.message || 'Erreur lors de la récupération des performances de clics');
      setClickPerformanceData(null);
      }
    } finally {
      // Toujours arrêter le loader, même en cas d'annulation
      setClickPerformanceLoading(false);
      console.log(`[DEBUG] Fin fetchClickPerformance`);
    }
  };

  // Fonction pour vérifier si un email est utilisé dans une campagne active ou programmée
  const isEmailInCampaign = useCallback((emailId) => {
    const findEmailInEvents = (events) => {
      for (const event of events) {
        if (event.type === 'email.send' && event.properties?.email == emailId) {
          return true;
        }
        if (event.children && event.children.length > 0) {
          if (findEmailInEvents(event.children)) {
            return true;
          }
        }
      }
      return false;
    };

    const campaignsUsingEmail = campaigns.filter(campaign => 
      campaign.events && findEmailInEvents(campaign.events)
    );

    if (campaignsUsingEmail.length === 0) {
      return false; // L'email n'est utilisé dans aucune campagne.
    }

    // Vérifie si au moins une des campagnes est active ou programmée
    const now = new Date();
    return campaignsUsingEmail.some(c => {
      if (!c.isPublished) {
        return false; // Ignore les brouillons
      }

      const publishUp = c.publishUp ? new Date(c.publishUp) : null;
      const publishDown = c.publishDown ? new Date(c.publishDown) : null;

      // Est programmée : la date de début est dans le futur
      const isScheduled = publishUp && publishUp > now;

      // Est en cours : la date de début est passée (ou absente) ET la date de fin n'est pas encore passée (ou absente)
      const isOngoing = (!publishUp || publishUp <= now) && (!publishDown || publishDown > now);

      return isScheduled || isOngoing;
    });

  }, [campaigns]);

  const isEmailArchived = useCallback((emailId) => {
    return archivedEmails.some(archived => archived.data_id === emailId);
  }, [archivedEmails]);

  const isFavorite = useCallback((emailId) => {
    return favoritesEmails.some(fav => String(fav.data_id) === String(emailId));
  }, [favoritesEmails]);

  const handleArchiveEmail = async (emailId) => {
    try {
      if (isEmailInCampaign(emailId)) {
        showNotification('Impossible d\'archiver cet email car il est utilisé dans une campagne active', 'warning');
        return;
      }

      await addArchive('email', emailId);
      setArchivedEmails(prev => [...prev, { data_type: 'email', data_id: emailId }]);
      
      // Mise à jour optimiste de la liste visible selon le filtre courant
      // - Sur "tous" et autres listes non-archivées: on retire l'élément immédiatement
      // - Sur "archived": l'élément reste (il vient d'être archivé)
      setEmails(prev => {
        if (statusFilter === 'archived') return prev;
        return prev.filter(e => String(e.id) !== String(emailId));
      });
      setTotalEmails(prev => {
        if (statusFilter === 'archived') return prev;
        return Math.max(0, Number(prev || 0) - 1);
      });
      
      // Déselectionner si c'était l'email sélectionné
      if (selectedEmailId === emailId) {
        setSelectedEmailId(null);
      }
      
      showNotification('Email archivé avec succès', 'success');
    } catch (error) {
      console.error('Erreur lors de l\'archivage:', error);
      showNotification(`Erreur lors de l'archivage: ${error.message}`, 'error');
    }
  };

  const handleRestoreEmail = async (emailId) => {
    try {
      await removeArchive('email', emailId);
      setArchivedEmails(prev => prev.filter(a => String(a.data_id) !== String(emailId)));
      
      // Mise à jour optimiste de la liste visible selon le filtre courant
      // - Sur "archived": on retire l'élément immédiatement (il n'est plus archivé)
      // - Sur autres listes: l'élément pourra réapparaître à la prochaine pagination
      setEmails(prev => {
        if (statusFilter === 'archived') {
          return prev.filter(e => String(e.id) !== String(emailId));
        }
        return prev;
      });
      setTotalEmails(prev => {
        if (statusFilter === 'archived') {
          return Math.max(0, Number(prev || 0) - 1);
        }
        return prev;
      });
      
      showNotification('Email restauré avec succès', 'success');
    } catch (error) {
      console.error('Erreur lors de la restauration:', error);
      showNotification(`Erreur lors de la restauration: ${error.message}`, 'error');
    }
  };

  const toggleFavorite = async (emailId) => {
    try {
      if (isFavorite(emailId)) {
        await removeFavorite('email', emailId);
        setFavoritesEmails(prev => prev.filter(fav => String(fav.data_id) !== String(emailId)));
        // Si on est sur la liste des favoris, retirer l'élément immédiatement
        if (statusFilter === 'favorites') {
          setEmails(prev => prev.filter(e => String(e.id) !== String(emailId)));
          setTotalEmails(prev => Math.max(0, Number(prev || 0) - 1));
        }
        showNotification('Email retiré des favoris', 'success');
      } else {
        const newFav = await addFavorite('email', emailId);
        setFavoritesEmails(prev => [...prev, newFav]);
        showNotification('Email ajouté aux favoris', 'success');
      }
    } catch (error) {
      console.error('Erreur lors de la gestion des favoris:', error);
      showNotification('Erreur lors de la gestion des favoris', 'error');
    }
  };

  const refreshCampaigns = async () => {
    try {
      const allCampaigns = [];
      let page = 1;
      const pageSize = 100;
      let hasMorePages = true;

      while (hasMorePages) {
        try {
          const response = await api.get('/campaigns', {
            params: { page, page_size: pageSize }
          });
          const campaignsData = response?.data?.campaigns || [];
          const total = response?.data?.total || 0;

          if (campaignsData.length > 0) {
            allCampaigns.push(...campaignsData);
          }

          hasMorePages = allCampaigns.length < total && campaignsData.length > 0;
          page++;

          if (page > 100) { // Safety break
            console.warn('Reached maximum page limit during campaign refresh.');
            break;
          }
        } catch (e) {
          console.error(`Failed to refresh campaigns page ${page}:`, e);
          hasMorePages = false; // Stop on error
        }
      }
      setCampaigns(allCampaigns);
    } catch (error) {
      console.error("Erreur lors du rafraîchissement des campagnes:", error);
    }
  };

  const fetchAbTestStatus = async (setLoadingState = false) => {
    if (setLoadingState) setLoading(true);
    try {
      const response = await api.get('/abtest_notify/');
      if (response.data && Array.isArray(response.data)) {
        const onGoingIds = response.data
          .flatMap(test => [test.parent_email_id, test.abtest_email_id])
          .filter(id => id != null);
        const uniqueOnGoingIds = [...new Set(onGoingIds)];
        setOnGoingAbTests(uniqueOnGoingIds);
      }
    } catch (error) {
      console.error("A/B test status refresh failed:", error);
    }
  };

  const fetchInitialData = useCallback(async () => {
    try {
      const results = await Promise.allSettled([
        api.get('/abtest_notify/'),
        api.get('/campaigns') // On récupère aussi les campagnes
      ]);

      const abTestsResult = results[0];
      const campaignsResult = results[1];

      if (abTestsResult.status === 'fulfilled') {
        const { data } = abTestsResult.value;
        if (data && Array.isArray(data)) {
          const onGoingIds = data.flatMap(test => [test.parent_email_id, test.abtest_email_id]).filter(id => id != null);
          const uniqueOnGoingIds = [...new Set(onGoingIds)];
          setOnGoingAbTests(uniqueOnGoingIds);
        }
      } else {
        console.error("A/B test status fetch failed:", abTestsResult.reason);
      }

      if (campaignsResult.status === 'fulfilled') {
        const allCampaigns = [];
        let page = 1;
        const pageSize = 100; // Fetch 100 campaigns per page
        let hasMorePages = true;

        while (hasMorePages) {
          try {
            const response = await api.get('/campaigns', {
              params: { page, page_size: pageSize }
            });
            const campaignsData = response?.data?.campaigns || [];
            const total = response?.data?.total || 0;
            
            if (campaignsData.length > 0) {
              allCampaigns.push(...campaignsData);
            }

            hasMorePages = allCampaigns.length < total && campaignsData.length > 0;
            page++;

            if (page > 100) { // Safety break
              console.warn('Reached maximum page limit while fetching campaigns.');
              break;
            }
          } catch (e) {
            console.error(`Failed to fetch campaigns page ${page}:`, e);
            hasMorePages = false; // Stop on error
          }
        }
        setCampaigns(allCampaigns);
      } else {
        console.error("Initial campaigns fetch failed:", campaignsResult.reason);
        setCampaigns([]);
      }

    } catch (e) {
      console.error("Unexpected error in fetchInitialData:", e);
    }
  }, []); // Les dépendances sont stables

  const [hasLoadedEmails, setHasLoadedEmails] = useState(false);
  // Permet de forcer un refetch explicite (ex: après création)
  const [refreshKey, setRefreshKey] = useState(0);

  // Prefetch favorites and archives as early as possible to avoid UI lag on icons
  useEffect(() => {
    (async () => {
      try {
        const [archives, favoritesData] = await Promise.all([
          getArchives('email').catch(() => []),
          getFavorites('email').catch(() => [])
        ]);
        setArchivedEmails(archives);
        setFavoritesEmails(favoritesData);
      } catch (_) {}
    })();
  }, []);

  useEffect(() => {
    if (!hasLoadedEmails) return;
    const initializeData = async () => {
      try {
        const [_, archives, favoritesData] = await Promise.all([
          fetchInitialData(),
          getArchives('email').catch(() => []),
          getFavorites('email').catch(() => [])
        ]);
        setArchivedEmails(archives);
        setFavoritesEmails(favoritesData);
      } catch (error) {
        console.error('Erreur lors de l\'initialisation:', error);
      }
    };
    initializeData();
  }, [fetchInitialData, hasLoadedEmails]);

  // Clear current selection whenever list-driving params change
  useEffect(() => {
    if (selectedEmailId) {
      setSelectedEmailId(null);
    }
  }, [page, pageSize, debouncedSearchTerm, sortBy, sortDirection, statusFilter, startDate, endDate]);

  // useEffect pour charger les statistiques quand un email est sélectionné et l'onglet Analyse & IA est actif
  useEffect(() => {
    if (selectedEmailId && tabValue === getTabIndex('Analyse & IA')) {
      console.log(`[DEBUG] Chargement des statistiques pour email ${selectedEmailId}`);
      
      // Réinitialiser les états quand on change d'email
      setEmailStats(null);
      setEmailStatsError(null);
      setEmailAnalysis(null);
      setEmailAnalysisError(null);
      
      // Charger les nouvelles statistiques
      fetchEmailStats(selectedEmailId);
    }
  }, [selectedEmailId, tabValue]);

  // useEffect pour nettoyer les données quand on change d'email ou d'onglet
  useEffect(() => {
    if (tabValue !== getTabIndex('Analyse & IA') || !selectedEmailId) {
      // Annuler les requêtes en cours
      if (emailAnalysisAbortController.current) {
        emailAnalysisAbortController.current.abort();
      }
      
      // Réinitialiser les états si on quitte l'onglet
      if (tabValue !== getTabIndex('Analyse & IA')) {
        setEmailStats(null);
        setEmailStatsError(null);
        setEmailAnalysis(null);
        setEmailAnalysisError(null);
      }
    }
  }, [selectedEmailId, tabValue]);

  const handleDeleteClick = (email) => {
    setSelectedEmail(email);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedEmail(null);
  };

  const handleConfirmDelete = async () => {
    if (!selectedEmail) return;
    setIsDeleting(true);

    try {
      const deletedId = selectedEmail.id;
      const resp = await api.delete(`/emails/delete/${deletedId}`);
      if (resp?.data?.success !== false && !resp?.data?.error) {
        // Clear selection if needed
        if (selectedEmailId === deletedId) {
          setSelectedEmailId(null);
        }

        // Compute new total and next page
        const newTotal = Math.max(0, (totalEmails || 0) - 1);
        const newTotalPages = Math.max(1, Math.ceil(newTotal / pageSize));
        const nextPage = Math.min(page, newTotalPages);

        // Optimistic: remove locally for immediate feedback
        setEmails(prev => prev.filter(e => e.id !== deletedId));
        setTotalEmails(newTotal);

        // Trigger a single refetch: either change page or refresh current page
        if (nextPage !== page) {
          setPage(nextPage);
        } else {
          try { setRefreshKey(prev => (Number(prev) || 0) + 1); } catch (_) {}
        }

      showNotification('Template d\'email supprimé avec succès.', 'success');
      } else {
        showNotification(resp?.data?.message || 'Erreur lors de la suppression du template.', 'error');
      }
    } catch (error) { 
      console.error('Erreur lors de la suppression du template:', error);
      showNotification('Erreur lors de la suppression du template.', 'error');
    } finally {
      setIsDeleting(false);
      handleCloseDialog();
    }
  };

  const handleDuplicateClick = (email) => {
    setEmailToClone(email);
    setNewName(''); // On initialise le champ à vide
    setRenameModalOpen(true);
  };

  const handleCloseRenameModal = () => {
    setRenameModalOpen(false);
    setEmailToClone(null);
    setNewName('');
  };

  const handleConfirmClone = async () => {
    if (!emailToClone) return;

    setIsCloning(true);
    setActionInProgress(emailToClone.id);
    try {
      // Le nouveau nom est envoyé en tant que paramètre de requête (query param)
      // Si `newName` est vide, le backend utilisera son nom par défaut
      const response = await api.post(`/emails/clone/${emailToClone.id}`, null, {
        params: { new_name: newName },
      });

      if (response.data && response.data.success) {
        showNotification('Template d\'email dupliqué avec succès.', 'success');
        // Forcer l\'actualisation de la liste pour refléter immédiatement le doublon
        // et revenir à la première page (tri récent d\'abord)
        try { setPage(1); } catch (_) {}
        try { setRefreshKey(prev => (Number(prev) || 0) + 1); } catch (_) {}
      } else {
        showNotification(response.data.message || 'Erreur lors de la duplication.', 'error');
      }
    } catch (error) {
      console.error('Erreur lors de la duplication du template:', error);
      showNotification('Erreur lors de la duplication du template.', 'error');
    } finally {
      setIsCloning(false);
      handleCloseRenameModal();
      setActionInProgress(null);
    }
  };

  // Get selected email details
  const selectedEmailDetails = useMemo(() => {
    return emails.find(email => email.id === selectedEmailId) || null;
  }, [emails, selectedEmailId]);

  // Filtered and sorted emails
  const filteredAndSortedEmails = useMemo(() => {
    let filtered = emails.filter(email => {
      // Recherche gérée côté serveur: ne pas re-filtrer localement sur le nom
      const matchesSearch = true;
      
      // Date filter is now handled server-side, no client-side filtering needed
      let matchesDate = true;
      // Apply filters based on statusFilter
      let matchesStatus = true;
      const emailIsArchived = isEmailArchived(email.id);
      const hasAbTestStructure = email.variantChildren?.length > 0 || email.variantParent;
      const isAbTestOngoing = onGoingAbTests.includes(email.id);
      
      if (statusFilter === 'archived') {
        // Seuls les emails archivés sont affichés
        matchesStatus = emailIsArchived;
      // A/B Test filters temporarily disabled
      /*
      } else if (statusFilter === 'abtest_all') {
        // Tous les emails A/B testés (en cours ou terminés)
        matchesStatus = !emailIsArchived && hasAbTestStructure;
      } else if (statusFilter === 'abtest_ongoing') {
        // A/B tests en cours uniquement
        matchesStatus = !emailIsArchived && hasAbTestStructure && isAbTestOngoing;
      } else if (statusFilter === 'abtest_completed') {
        // A/B tests terminés uniquement
        matchesStatus = !emailIsArchived && hasAbTestStructure && !isAbTestOngoing;
      */
      } else if (statusFilter === 'date') {
        // Filtre par date uniquement - exclure les archivés mais appliquer le filtre de date
        matchesStatus = !emailIsArchived;
        // Le filtre de date sera appliqué via matchesDate
      } else {
        // Pour tous les autres filtres, exclure les emails archivés
        if (emailIsArchived) {
          matchesStatus = false;
        } else if (statusFilter === 'favorites') {
          matchesStatus = isFavorite(email.id);
        } else if (statusFilter === 'published') {
          matchesStatus = email.isPublished;
        } else if (statusFilter === 'draft') {
          matchesStatus = !email.isPublished;
        }
        // 'all' shows everything except archived, so matchesStatus stays true if not archived
      }
      
      return matchesSearch && matchesStatus && matchesDate;
    });

    // Sort emails
    filtered.sort((a, b) => {
      let comparison = 0;
      switch (sortBy) {
        case 'name':
          comparison = a.name.localeCompare(b.name);
          break;
        case 'created':
          // Pour les dates : plus récent d'abord par défaut (desc)
          comparison = new Date(b.dateAdded || 0) - new Date(a.dateAdded || 0);
          break;
        case 'modified':
        default:
          // Pour les dates : plus récent d'abord par défaut (desc)
          comparison = new Date(b.dateModified || b.dateAdded || 0) - new Date(a.dateModified || a.dateAdded || 0);
          break;
      }
      // Si asc, on inverse la comparaison
      return sortDirection === 'asc' ? -comparison : comparison;
    });

    return filtered;
  }, [emails, search, statusFilter, sortBy, sortDirection, favorites, startDate, endDate, archivedEmails, favoritesEmails]);

  // Pagination (server-side): rely on totalEmails for page count; list already paged
  const pageCount = Math.ceil((totalEmails || filteredAndSortedEmails.length) / pageSize);
  const paginatedEmails = emails; // server already returns current page

  // Reset page when filters change and current page is out of bounds
  useEffect(() => {
    if (pageCount > 0 && page > pageCount) {
      setPage(1);
    }
  }, [pageCount, page]);

  // Debounce search to reduce flicker and extra requests
  useEffect(() => {
    const handle = setTimeout(() => setDebouncedSearchTerm(search), 300);
    return () => clearTimeout(handle);
  }, [search]);

  // Reset page when search or filters change (keep current list to avoid empty flicker)
  useEffect(() => {
    setPage(1);
  }, [search, statusFilter, startDate, endDate]);

  // Suppress auto-selection on load; user must select an email explicitly
  // (Previously: auto-selected the first email when data was loaded)
  useEffect(() => {
    // Intentionally left blank to avoid auto-selecting emails on load
  }, [paginatedEmails, loading, selectedEmailId]);

  // When filtered list changes and current selection is not in filtered results, clear selection (no auto-select)
  useEffect(() => {
    if (!loading && filteredAndSortedEmails.length > 0 && selectedEmailId) {
      // Check if currently selected email is still in the filtered results
      const isCurrentEmailInFiltered = filteredAndSortedEmails.some(email => email.id === selectedEmailId);
      if (!isCurrentEmailInFiltered) {
        // Current email is not in filtered results, clear selection to let user choose
        setSelectedEmailId(null);
      }
    } else if (!loading && filteredAndSortedEmails.length === 0 && selectedEmailId) {
      // No emails in filtered results, clear selection
      setSelectedEmailId(null);
    }
  }, [filteredAndSortedEmails, selectedEmailId, loading]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleEmailSelect = (id) => {
    setSelectedEmailId(id);
  };

  // Navigation de pagination (évite l'affichage transitoire de l'ancienne page)
  const goToPage = (newPage) => {
    if (newPage === page) return;
    setLoading(true);
    setEmails([]);
    setPage(newPage);
  };

  // Fetch paginated emails when page, pageSize, search, filters, or sort changes
  const latestRequestIdRef = useRef(0);

  useEffect(() => {
    const controller = new AbortController();
    const fetchEmails = async () => {
      const requestId = ++latestRequestIdRef.current;
      setLoading(true);
      setError(null);
      try {
        const params = {
          page,
          page_size: pageSize,
          search: debouncedSearchTerm || undefined,
          sort_field: sortBy,
          sort_direction: sortDirection,
          favorites_only: statusFilter === 'favorites' ? true : undefined,
          archived_only: statusFilter === 'archived' ? true : undefined,
        };
        if (statusFilter === 'published') {
          params.is_published = true;
        } else if (statusFilter === 'draft') {
          params.is_published = false;
        }
        if (statusFilter === 'date' && (startDate || endDate)) {
          params.date_field = 'dateModified';
          if (startDate) params.date_from = new Date(startDate).toISOString().slice(0, 19).replace('T', ' ');
          if (endDate) params.date_to = new Date(endDate).toISOString().slice(0, 19).replace('T', ' ');
        }
        const resp = await api.get('/emails', { params, signal: controller.signal });
        const data = resp?.data || {};
        if (data.success) {
          if (latestRequestIdRef.current === requestId) {
            setEmails(Array.isArray(data.emails) ? data.emails : []);
            setTotalEmails(Number(data.total || 0));
            setHasLoadedEmails(true);
          }
        } else {
          if (latestRequestIdRef.current === requestId) {
            setError('Erreur lors du chargement des emails');
            setEmails([]);
            setTotalEmails(0);
          }
        }
      } catch (err) {
        if (err.name !== 'CanceledError' && latestRequestIdRef.current === requestId) {
          console.error('Erreur lors du chargement des emails:', err);
          setError(err.message || 'Erreur lors du chargement des emails');
          setEmails([]);
          setTotalEmails(0);
        }
      } finally {
        if (latestRequestIdRef.current === requestId) {
          setLoading(false);
        }
      }
    };
    fetchEmails();
    return () => controller.abort();
  }, [page, pageSize, debouncedSearchTerm, sortBy, sortDirection, statusFilter, startDate, endDate, refreshKey]);

  // useEffect pour récupérer les données A/B test quand un email est sélectionné
  useEffect(() => {
    if (selectedEmailId) {
      // Récupérer les données A/B test quand un email est sélectionné
      fetchAbTestData(selectedEmailId);
    }
  }, [selectedEmailId]);

  // Fonction pour déterminer la couleur du taux
  const getRateColor = (rateString) => {
    // Extraire le nombre du pourcentage (ex: "45.67%" -> 45.67)
    const rate = parseFloat(rateString.replace('%', ''));
    
    if (rate < 50) {
      return '#DC2626'; // Rouge pour taux faible
    } else if (rate === 50) {
      return '#F59E0B'; // Orange pour taux neutre
    } else {
      return '#059669'; // Vert pour taux élevé
    }
  };

  // useEffect pour récupérer les performances de clics quand un email est sélectionné et l'onglet Performance est ouvert
  useEffect(() => {
    if (selectedEmailId && tabValue === getTabIndex('Performance des Clics')) { // Onglet Performance des Clics
      fetchClickPerformance(selectedEmailId);
    }
    // If switching away from performance tab or clearing selection, cancel in-flight
    if (!selectedEmailId || tabValue !== getTabIndex('Performance des Clics')) {
      if (clickPerfControllerRef.current) {
        try { clickPerfControllerRef.current.abort(); } catch (_) {}
      }
    }
  }, [selectedEmailId, tabValue]);

  const handleActionsMenuOpen = (event) => {
    setActionsMenuAnchor(event.currentTarget);
  };

  const handleActionsMenuClose = () => {
    setActionsMenuAnchor(null);
  };

  const handleStatusMenuOpen = (event) => {
    setStatusMenuAnchor(event.currentTarget);
  };

  const handleStatusMenuClose = () => {
    setStatusMenuAnchor(null);
  };

  const handleSortMenuOpen = (event) => {
    setSortMenuAnchor(event.currentTarget);
  };

  const handleSortMenuClose = () => {
    setSortMenuAnchor(null);
  };

  const openSpamModal = async () => {
    setSpamModalOpen(true);
    setSpamError(null);
    setIsSpamReportLoading(true);
    setSpamReport(null);
    setSpamFormData({
      from: 'contact@qilinsa.com',
      subject: selectedEmailDetails?.subject || '',
    });
    // Use subject as emailId (or fallback to id)
    const emailId = selectedEmailDetails?.subject || selectedEmailDetails?.id?.toString() || '';
    try {
      const report = await spamServices.getLatestSpamReport(emailId);
      if (report) {
        setSpamReport(report);
      } else {
        setSpamReport(null);
      }
    } catch (err) {
      setSpamReport(null);
      setSpamError('Erreur lors de la récupération du rapport anti-spam.');
    } finally {
      setIsSpamReportLoading(false);
    }
  };

  const handleAnalyze = async () => {
    setIsAnalyzing(true);
    setSpamError(null);
    try {
      const emailData = {
        htmlContent: selectedEmailDetails.html || selectedEmailDetails.customHtml || '',
        from: spamFormData.from,
        to: spamFormData.to,
        subject: spamFormData.subject
      };
      const report = await spamServices.checkSpam(emailData);
      setSpamReport(report);
    } catch (error) {
      setSpamError(error.message || 'Failed to analyze email. Please try again later.');
    } finally {
      setIsAnalyzing(false);
    }
  };

  const searchContacts = useCallback(async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
      setContactOptions([]);
      return;
    }
    setContactsLoading(true);
    try {
      const response = await api.post('/profiles/search', {
        search_term: searchTerm,
        offset: 0,
        limit: 10,
        sort_by: "properties.firstName:asc"
      });

      if (response.data && response.data.profiles) {
        // Filter profiles that have email addresses
        const contactsWithEmails = response.data.profiles.filter(profile => 
          profile.properties && profile.properties.email
        );
        
        setContactOptions(contactsWithEmails);
      } else {
        setContactOptions([]);
      }
    } catch (error) {
      console.error('Error searching contacts:', error);
      setContactOptions([]);
    } finally {
      setContactsLoading(false);
    }
  }, []); // Pas de dépendances car on utilise des setState et api est stable

  // Debounced search for contacts (used in test email modal)
  const debouncedSearchContacts = useMemo(
    () => debounce((term) => { searchContacts(term); }, 300),
    [searchContacts]
  );

  useEffect(() => {
    return () => {
      if (debouncedSearchContacts && debouncedSearchContacts.cancel) {
        debouncedSearchContacts.cancel();
      }
    };
  }, [debouncedSearchContacts]);

  const isValidEmail = (email) => {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
  };

  // Fonctions pour le modal d'envoi de test
  const openTestEmailModal = () => {
    setTestEmailModalOpen(true);
    setTestEmailError(null);
    setTestEmailSuccess(false);
    setTestRecipients([]);
    setRecipientInput('');
    setTestSubject(selectedEmailDetails?.subject || '');
  };

  const getDateFilterLabel = () => {
    if (!startDate && !endDate) return '';
    
    if (startDate && endDate) {
      return `Du ${new Date(startDate).toLocaleDateString('fr-FR')} au ${new Date(endDate).toLocaleDateString('fr-FR')}`;
    } else if (startDate) {
      return `À partir du ${new Date(startDate).toLocaleDateString('fr-FR')}`;
    } else if (endDate) {
      return `Jusqu'au ${new Date(endDate).toLocaleDateString('fr-FR')}`;
    }
    return '';
  };

  const handleTogglePublishStatus = async (emailId, newStatus) => {
    try {
      console.log(`[DEBUG] Toggling email ${emailId} to ${newStatus ? 'published' : 'unpublished'}`);
      
      const response = await api.patch(`/emails/${emailId}/toggle-publish`, {
        isPublished: newStatus
      });
      
      console.log('[DEBUG] API Response:', response.data);
      
      if (response.data.success) {
        // Mettre à jour l'état local
        setEmails(prevEmails => 
          prevEmails.map(email => 
            email.id === emailId 
              ? { ...email, isPublished: newStatus }
              : email
          )
        );

        // Si on est sur une vue filtrée par statut, retirer l'élément qui ne correspond plus
        // - Sur "Publié": si on désactive -> retirer de la liste et décrémenter le total
        // - Sur "Brouillon": si on active -> retirer de la liste et décrémenter le total
        if ((statusFilter === 'published' && !newStatus) || (statusFilter === 'draft' && newStatus)) {
          setEmails(prev => prev.filter(e => String(e.id) !== String(emailId)));
          setTotalEmails(prev => Math.max(0, Number(prev || 0) - 1));
          if (String(selectedEmailId) === String(emailId)) {
            setSelectedEmailId(null);
          }
        }
        
        const statusText = newStatus ? 'activé' : 'désactivé';
        showNotification(`Email ${statusText} avec succès`, 'success');
      } else {
        console.error('[DEBUG] API returned error:', response.data.message);
        showNotification(response.data.message || 'Erreur lors de la modification du statut', 'error');
      }
    } catch (error) {
      console.error('[DEBUG] Exception caught:', error);
      console.error('[DEBUG] Error response:', error.response?.data);
      
      // Afficher l'erreur spécifique du backend si disponible
      const errorMessage = error.response?.data?.detail || error.response?.data?.message || 'Erreur lors de la modification du statut de l\'email';
      showNotification(errorMessage, 'error');
    }
  };

  // Fonction pour récupérer les données A/B test
  const fetchAbTestData = async (emailId) => {
    // Vérifier d'abord si l'email fait partie des A/B tests connus OU s'il a des variantes
    const selectedEmail = emails.find(e => e.id === emailId);
    const hasAbTestStructure = selectedEmail && (
      selectedEmail.variantChildren?.length > 0 || 
      selectedEmail.variantParent ||
      onGoingAbTests.includes(emailId)
    );
    
    if (!hasAbTestStructure) {
      // Pas d'A/B test pour cet email, afficher directement le message
      setAbTestData(null);
      setAbTestLoading(false);
      setAbTestError(null);
      return;
    }

    // Annuler la requête précédente si elle existe
    if (abTestControllerRef.current) {
      abTestControllerRef.current.abort();
    }

    // Créer un nouveau contrôleur d'annulation
    const controller = new AbortController();
    abTestControllerRef.current = controller;

    // Cross-cancel other detail requests to avoid parallel load
    if (contactsControllerRef.current) {
      try { contactsControllerRef.current.abort(); } catch (_) {}
    }
    if (clickPerfControllerRef.current) {
      try { clickPerfControllerRef.current.abort(); } catch (_) {}
    }

    setAbTestLoading(true);
    setAbTestError(null);
    
    try {
      console.log(`[DEBUG] Fetching A/B test data for email ID: ${emailId}`);
      
      let response = await api.get(`/abtest_notify/results/${emailId}`, {
        signal: controller.signal
      });
      console.log(`[DEBUG] A/B test API response:`, response.data);
      
      if (response.data.error) {
        console.log(`[DEBUG] A/B test error: ${response.data.message}`);
        console.log(`[DEBUG] Trying raw API as fallback...`);
        
        const rawResponse = await api.get(`/abtest_notify/results_raw/${emailId}`, {
          signal: controller.signal
        });
        console.log(`[DEBUG] Raw A/B test API response:`, rawResponse.data);
        
        if (!rawResponse.data.error && rawResponse.data.variations && rawResponse.data.variations.length > 1) {
          const variations = rawResponse.data.variations;
          
          // Utiliser les critères définis lors du lancement de l'A/B test ou par défaut 'email.openrate'
          const criteria = rawResponse.data.criteria || 'email.openrate';
          
          // Déterminer le gagnant basé sur les critères définis
          const winner = variations.reduce((prev, current) => {
            let prevScore, currentScore;
            
            switch (criteria) {
              case 'email.clickrate':
                prevScore = prev.clickrate || 0;
                currentScore = current.clickrate || 0;
                break;
              case 'email.downloads':
                prevScore = prev.downloads || 0;
                currentScore = current.downloads || 0;
                break;
              case 'email.submissions':
                prevScore = prev.submissions || 0;
                currentScore = current.submissions || 0;
                break;
              case 'email.conversion':
                // Score composite: openrate + clickrate*2 + downloads*1.5 + submissions*3
                prevScore = (prev.openrate || 0) + (prev.clickrate || 0) * 2 + (prev.downloads || 0) * 1.5 + (prev.submissions || 0) * 3;
                currentScore = (current.openrate || 0) + (current.clickrate || 0) * 2 + (current.downloads || 0) * 1.5 + (current.submissions || 0) * 3;
                break;
              case 'email.openrate':
              default:
                prevScore = prev.openrate || 0;
                currentScore = current.openrate || 0;
                break;
            }
            
            return currentScore > prevScore ? current : prev;
          });
          
          const transformedData = {
            status: "Analyse directe",
            parent_email_id: emailId,
            criteria: criteria,
            winner: winner,
            variations: variations.map(v => ({
              ...v,
              score: (() => {
                switch (criteria) {
                  case 'email.clickrate': return v.clickrate || 0;
                  case 'email.downloads': return v.downloads || 0;
                  case 'email.submissions': return v.submissions || 0;
                  case 'email.conversion': return (v.openrate || 0) + (v.clickrate || 0) * 2 + (v.downloads || 0) * 1.5 + (v.submissions || 0) * 3;
                  case 'email.openrate':
                  default: return v.openrate || 0;
                }
              })(),
              stats: {
                openrate: v.openrate || 0,
                clickrate: v.clickrate || 0,
                sentCount: v.stats?.sentCount || 0,
                readCount: v.stats?.readCount || 0
              }
            })),
            abtest: {
              start_date: null,
              end_date: null
            }
          };
          setAbTestData(transformedData);
        } else {
          setAbTestData(null);
        }
      } else if (response.data.variations && response.data.variations.length > 1) {
        // Utiliser les données de l'API normale avec les critères définis
        const apiData = response.data;
        const criteria = apiData.criteria || 'email.openrate';
        
        // S'assurer que le gagnant est correctement déterminé selon les critères
        if (!apiData.winner && apiData.variations) {
          const winner = apiData.variations.reduce((prev, current) => {
            let prevScore, currentScore;
            
            switch (criteria) {
              case 'email.clickrate':
                prevScore = prev.stats?.clickrate || prev.clickrate || 0;
                currentScore = current.stats?.clickrate || current.clickrate || 0;
                break;
              case 'email.downloads':
                prevScore = prev.stats?.downloads || prev.downloads || 0;
                currentScore = current.stats?.downloads || current.downloads || 0;
                break;
              case 'email.submissions':
                prevScore = prev.stats?.submissions || prev.submissions || 0;
                currentScore = current.stats?.submissions || current.submissions || 0;
                break;
              case 'email.conversion':
                prevScore = (prev.stats?.openrate || prev.openrate || 0) + (prev.stats?.clickrate || prev.clickrate || 0) * 2 + (prev.stats?.downloads || prev.downloads || 0) * 1.5 + (prev.stats?.submissions || prev.submissions || 0) * 3;
                currentScore = (current.stats?.openrate || current.openrate || 0) + (current.stats?.clickrate || current.clickrate || 0) * 2 + (current.stats?.downloads || current.downloads || 0) * 1.5 + (current.stats?.submissions || current.submissions || 0) * 3;
                break;
              case 'email.openrate':
              default:
                prevScore = prev.stats?.openrate || prev.openrate || 0;
                currentScore = current.stats?.openrate || current.openrate || 0;
                break;
            }
            
            return currentScore > prevScore ? current : prev;
          });
          apiData.winner = winner;
        }
        
        setAbTestData(apiData);
      } else {
        setAbTestData(null);
      }
    } catch (error) {
      // Ne pas traiter les erreurs d'annulation comme des erreurs réelles
      if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
        console.log('[DEBUG] A/B test request was cancelled');
        return;
      }
      
      console.error("Error fetching A/B test data:", error);
      setAbTestError("Une erreur est survenue lors de la récupération des données du test A/B.");
      setAbTestData(null);
    } finally {
      // Ne mettre à jour le loading que si cette requête n'a pas été annulée
      if (!controller.signal.aborted) {
        setAbTestLoading(false);
      }
      
      // Nettoyer la référence si c'est la requête actuelle
      if (abTestControllerRef.current === controller) {
        abTestControllerRef.current = null;
      }
    }
  };

  // Fonction pour calculer l'amélioration statistique
  // Fonction pour formater l'analyse IA avec une belle présentation
  const renderFormattedAnalysis = (analysisText) => {
    if (!analysisText) return null;

    const lines = analysisText.split('\n');
    const elements = [];
    let currentSection = null;
    let listItems = [];

    const processListItems = () => {
      if (listItems.length > 0) {
        elements.push(
          <Box key={`list-${elements.length}`} sx={{ mb: 2 }}>
            {listItems.map((item, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                <Box sx={{ 
                  width: 6, 
                  height: 6, 
                  borderRadius: '50%', 
                  bgcolor: '#3B82F6', 
                  mt: 1, 
                  mr: 2,
                  flexShrink: 0 
                }} />
                <Typography variant="body2" sx={{ color: '#374151', lineHeight: 1.6 }}>
                  {item}
                </Typography>
              </Box>
            ))}
          </Box>
        );
        listItems = [];
      }
    };

    lines.forEach((line, index) => {
      const trimmedLine = line.trim();
      
      if (!trimmedLine) return;

      // Titre principal (###)
      if (trimmedLine.startsWith('### ')) {
        processListItems();
        const title = trimmedLine.replace('### ', '').replace(/\*\*/g, '');
        
        // Déterminer l'icône et la couleur selon le contenu
        let icon = null;
        let borderColor = '#3B82F6';
        let bgColor = '#EFF6FF';
        
        if (title.toLowerCase().includes('synthèse') || title.toLowerCase().includes('résumé')) {
          icon = <TrendingUpIcon sx={{ fontSize: 20, color: '#3B82F6' }} />;
        } else if (title.toLowerCase().includes('performance') || title.toLowerCase().includes('évaluation')) {
          icon = <MouseIcon sx={{ fontSize: 20, color: '#059669' }} />;
          borderColor = '#059669';
          bgColor = '#ECFDF5';
        } else if (title.toLowerCase().includes('points forts') || title.toLowerCase().includes('points faibles')) {
          icon = <CompareArrowsIcon sx={{ fontSize: 20, color: '#DC2626' }} />;
          borderColor = '#DC2626';
          bgColor = '#FEF2F2';
        } else if (title.toLowerCase().includes('suggestion') || title.toLowerCase().includes('amélioration')) {
          icon = <FlashOnIcon sx={{ fontSize: 20, color: '#F59E0B' }} />;
          borderColor = '#F59E0B';
          bgColor = '#FFFBEB';
        } else if (title.toLowerCase().includes('recommandation') || title.toLowerCase().includes('prochaine')) {
          icon = <CalendarTodayIcon sx={{ fontSize: 20, color: '#8B5CF6' }} />;
          borderColor = '#8B5CF6';
          bgColor = '#F3E8FF';
        } else if (title.toLowerCase().includes('engagement') || title.toLowerCase().includes('clic')) {
          icon = <AdsClickIcon sx={{ fontSize: 20, color: '#06B6D4' }} />;
          borderColor = '#06B6D4';
          bgColor = '#ECFEFF';
        }
        
        elements.push(
          <Box key={index} sx={{ mb: 3, mt: index > 0 ? 4 : 0 }}>
            <Box sx={{ 
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 2,
              borderRadius: 2,
              bgcolor: bgColor,
              border: `1px solid ${borderColor}20`,
              borderLeft: `4px solid ${borderColor}`,
              mb: 2
            }}>
              {icon}
              <Typography variant="h6" sx={{ 
                fontWeight: 700, 
                color: '#1F2937',
                fontSize: '1.1rem'
              }}>
                {title}
              </Typography>
            </Box>
          </Box>
        );
      }
      // Sous-titre (####)
      else if (trimmedLine.startsWith('#### ')) {
        processListItems();
        const subtitle = trimmedLine.replace('#### ', '').replace(/\*\*/g, '');
        elements.push(
          <Typography key={index} variant="subtitle1" sx={{ 
            fontWeight: 600, 
            color: '#374151',
            fontSize: '1rem',
            mb: 2,
            mt: 3
          }}>
            {subtitle}
          </Typography>
        );
      }
      // Séparateur (---)
      else if (trimmedLine.startsWith('---')) {
        processListItems();
        elements.push(
          <Divider key={index} sx={{ my: 3, borderColor: '#E5E7EB' }} />
        );
      }
      // Liste à puces (*)
      else if (trimmedLine.startsWith('*   ') || trimmedLine.startsWith('* ')) {
        const item = trimmedLine.replace(/^\*\s+/, '').replace(/\*\*/g, '');
        listItems.push(item);
      }
      // Liste numérotée
      else if (/^\d+\.\s+/.test(trimmedLine)) {
        processListItems();
        const item = trimmedLine.replace(/^\d+\.\s+/, '').replace(/\*\*/g, '');
        elements.push(
          <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
            <Box sx={{ 
              minWidth: 24, 
              height: 24, 
              borderRadius: '50%', 
              bgcolor: '#EFF6FF', 
              color: '#3B82F6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.75rem',
              fontWeight: 600,
              mr: 2,
              mt: 0.25
            }}>
              {trimmedLine.match(/^(\d+)/)[1]}
            </Box>
            <Typography variant="body2" sx={{ color: '#374151', lineHeight: 1.6 }}>
              {item}
            </Typography>
          </Box>
        );
      }
      // Texte en gras (**text**)
      else if (trimmedLine.includes('**')) {
        processListItems();
        const parts = trimmedLine.split(/(\*\*[^*]+\*\*)/);
        elements.push(
          <Typography key={index} variant="body2" sx={{ mb: 2, lineHeight: 1.6, color: '#374151' }}>
            {parts.map((part, partIndex) => {
              if (part.startsWith('**') && part.endsWith('**')) {
                const text = part.replace(/\*\*/g, '');
                
                // Vérifier si c'est une métrique (contient % ou des mots-clés)
                const isMetric = text.includes('%') || 
                               text.toLowerCase().includes('taux') ||
                               text.toLowerCase().includes('ctor') ||
                               text.toLowerCase().includes('amélioration') ||
                               /\d+/.test(text);
                
                if (isMetric) {
                  // Déterminer la couleur selon la valeur
                  let bgColor = '#EFF6FF';
                  let textColor = '#1E40AF';
                  
                  if (text.includes('%')) {
                    const percentage = parseFloat(text.match(/(\d+(?:\.\d+)?)/)?.[1] || 0);
                    if (percentage >= 50) {
                      bgColor = '#ECFDF5';
                      textColor = '#065F46';
                    } else if (percentage >= 20) {
                      bgColor = '#FFFBEB';
                      textColor = '#92400E';
                    } else {
                      bgColor = '#FEF2F2';
                      textColor = '#991B1B';
                    }
                  }
                  
                  return (
                    <Box 
                      key={partIndex} 
                      component="span" 
                      sx={{ 
                        fontWeight: 600,
                        color: textColor,
                        bgcolor: bgColor,
                        px: 1,
                        py: 0.25,
                        borderRadius: 1,
                        fontSize: '0.875rem',
                        border: `1px solid ${textColor}20`
                      }}
                    >
                      {text}
                    </Box>
                  );
                }
                
                return (
                  <Box key={partIndex} component="span" sx={{ fontWeight: 600, color: '#1F2937' }}>
                    {text}
                  </Box>
                );
              }
              return part;
            })}
          </Typography>
        );
      }
      // Texte normal
      else {
        processListItems();
        elements.push(
          <Typography key={index} variant="body2" sx={{ 
            mb: 2, 
            lineHeight: 1.6, 
            color: '#374151' 
          }}>
            {trimmedLine}
          </Typography>
        );
      }
    });

    processListItems(); // Process any remaining list items

    return <Box>{elements}</Box>;
  };

  const calculateImprovement = (metricName, winnerValue, loserValue) => {
    // Gestion des cas où les valeurs sont nulles, undefined ou 0
    if (winnerValue == null || loserValue == null) return null;
    if (loserValue === 0) {
      // Si loser = 0 et winner > 0, c'est une amélioration infinie (100%+)
      return winnerValue > 0 ? 100 : null;
    }
    if (winnerValue === 0 && loserValue > 0) {
      // Si winner = 0 et loser > 0, c'est une dégradation de -100%
      return -100;
    }
    
    const improvement = ((winnerValue - loserValue) / loserValue) * 100;
    // Éviter les valeurs aberrantes (limiter à ±500% pour plus de réalisme)
    if (Math.abs(improvement) > 500) {
      return improvement > 0 ? 500 : -500;
    }
    return improvement;
  };

  const handleSendTest = async () => {
    if (testRecipients.length === 0) {
      setTestEmailError('Veuillez ajouter au moins un destinataire.');
      return;
    }

    setIsSendingTest(true);
    setTestEmailError(null);
    
    try {
      const emailData = {
        email_id: selectedEmailDetails.id,
        recipients: testRecipients,
        subject: testSubject || selectedEmailDetails.subject
      };
      
      const response = await api.post('/emails/send-test', emailData);

      // Gestion spécifique du quota atteint
      if (response.data?.quota_exceeded && response.data?.resource === 'emails') {
        const msg = response.data.message || "Limite atteinte ❗ Vous avez atteint la totalité de votre quota d'emails pour ce mois-ci. Pour continuer vos envois, passez à un abonnement supérieur ou achetez un pack de surplus email.";
        setTestEmailError(msg);
        showNotification(msg, 'error');
        return;
      }
      
      if (response.data.success) {
        setTestEmailSuccess(true);
        showNotification('Email de test envoyé avec succès!', 'success');
        setTimeout(() => {
          setTestEmailModalOpen(false);
        }, 2000);
      } else {
        setTestEmailError(response.data.message || 'Erreur lors de l\'envoi du test.');
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi du test:', error);
      setTestEmailError(error.response?.data?.message || 'Erreur lors de l\'envoi du test email.');
    } finally {
      setIsSendingTest(false);
    }
  };

  // Tour steps configuration
  const tourSteps = useMemo(() => [
    {
      target: '[data-tourid="sidebar-toggle"]',
      content: 'Utilisez ce bouton pour afficher ou masquer le panneau des filtres et statuts.',
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tourid="sidebar-filters"]',
      content: 'Utilisez ces filtres pour afficher tous les templates, vos favoris, filtrer par date ou voir les templates archivés. Vous pouvez également filtrer par statut (publié ou brouillon).',
      placement: 'right',
    },
    {
      target: '[data-tourid="new-template-button"]',
      content: 'Cliquez ici pour créer un nouveau template d\'email. Vous pouvez choisir entre une création assistée par IA ou une création manuelle.',
      placement: 'bottom',
    },
    {
      target: '[data-tourid="search-templates"]',
      content: 'Utilisez cette barre de recherche pour trouver rapidement un template par son nom.',
      placement: 'bottom',
    },
    {
      target: '[data-tourid="sort-templates"]',
      content: 'Utilisez ces contrôles pour trier vos templates par nom, date de modification ou date de création, en ordre croissant ou décroissant.',
      placement: 'bottom',
    },
    {
      target: '[data-tourid="templates-list"]',
      content: 'Voici la liste de tous vos templates d\'email. Cliquez sur un template pour voir ses détails et aperçu. Utilisez les icônes pour activer, cloner, archiver ou supprimer.',
      placement: 'left',
    },
    {
      target: '[data-tourid="email-details"]',
      content: 'Lorsque vous sélectionnez un template, ses détails s\'affichent ici. Vous pouvez voir l\'aperçu, accéder aux statistiques, aux contacts, aux performances et à la configuration.',
      placement: 'left',
    },
    {
      target: '[data-tourid="email-tabs"]',
      content: 'Utilisez ces onglets pour naviguer entre les différentes vues : Analyse & IA, Contacts, Performance des Clics, A/B Test et Configuration.',
      placement: 'bottom',
    },
    {
      target: '[data-tourid="pagination"]',
      content: 'Utilisez la pagination pour naviguer entre les pages de templates. Vous pouvez également modifier le nombre d\'éléments par page.',
      placement: 'top',
    },
  ], []);

  // Handle tour callbacks
  const handleTourCallback = useCallback((data) => {
    const { status, type, index } = data;
    
    console.log('Tour callback:', { status, type, index, step: tourSteps[index]?.target });
    
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      setRunTour(false);
      // Save to localStorage that user has completed the tour
      localStorage.setItem('emails-tour-completed', 'true');
    } else if (type === EVENTS.STEP_BEFORE) {
      // Ensure sidebar is open for steps that require it (should already be open from tour start)
      if ((index === 0 || index === 1) && subMenuCollapsed) {
        setSubMenuCollapsed(false);
      }
      // Select an email if needed for details panel steps
      if ((index === 6 || index === 7) && !selectedEmailId && emails.length > 0) {
        // Don't auto-select, just let the tour show the empty state message
      }
    } else if (type === EVENTS.TARGET_NOT_FOUND) {
      // If target not found, log it but let joyride handle it
      console.warn('Target not found for step', index, 'target:', tourSteps[index]?.target);
    }
  }, [tourSteps, subMenuCollapsed, selectedEmailId, emails]);

  // Auto-start tour for first-time users
  useEffect(() => {
    const tourCompleted = localStorage.getItem('emails-tour-completed');
    // Auto-start tour for first-time users
    if (!tourCompleted) {
      // Open sidebar before starting tour to ensure elements are in DOM
      if (subMenuCollapsed) {
        setSubMenuCollapsed(false);
      }
      // Wait a bit longer to ensure sidebar is fully rendered
      setTimeout(() => setRunTour(true), 1500);
    }
  }, [subMenuCollapsed]);

  return (
    <Box sx={{ height: 'calc(100vh - 100px)', display: 'flex', flexDirection: 'column' }}>
      {/* Joyride Tour Component */}
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous={true}
        showProgress={true}
        showSkipButton={true}
        callback={handleTourCallback}
        disableOverlayClose={false}
        disableScrolling={false}
        spotlightClicks={false}
        floaterProps={{
          disableAnimation: false,
        }}
        scrollOffset={20}
        styles={{
          options: {
            primaryColor: '#007B8A',
            zIndex: 10000,
          },
          tooltip: {
            borderRadius: 8,
            fontFamily: 'Montserrat, Arial, sans-serif',
          },
          buttonNext: {
            backgroundColor: '#007B8A',
            fontSize: 14,
            padding: '8px 16px',
            borderRadius: 4,
            fontFamily: 'Montserrat, Arial, sans-serif',
          },
          buttonBack: {
            color: '#007B8A',
            fontSize: 14,
            fontFamily: 'Montserrat, Arial, sans-serif',
          },
          buttonSkip: {
            color: '#666',
            fontSize: 14,
            fontFamily: 'Montserrat, Arial, sans-serif',
          },
        }}
        locale={{
          back: 'Précédent',
          close: 'Fermer',
          last: 'Terminer',
          next: 'Suivant',
          skip: 'Passer',
        }}
      />
      
      <Box sx={{ display: 'flex', flex: 1, gap: 0, overflow: 'hidden' }}>
        {/* Sub-Menu Sidebar - Completely Hidden When Collapsed */}
        {subMenuCollapsed ? (
          // Sidebar complètement cachée, pas d'espace visible
          null
        ) : (
          <Paper sx={{ 
            width: 240, 
            minWidth: 240,
            borderRadius: 0, 
            borderRight: '1px solid #E5E7EB', 
            display: 'flex', 
            flexDirection: 'column', 
            bgcolor: '#F9FAFB',
            transition: 'width 0.3s ease-in-out',
            p: 2,
            height: '100%',
            overflow: 'hidden'
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" sx={{ 
                fontWeight: 600, 
                fontSize: '1.125rem', 
                color: '#1F2937'
              }}>
                Emails
              </Typography>

            </Box>
            
            {/* Navigation Filters - Scrollable Container */}
            <Box sx={{ 
              flex: 1,
              overflow: 'auto',
              mb: 3,
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#c1c1c1',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#a8a8a8',
              },
            }} data-tourid="sidebar-filters">
              <Box 
                onClick={() => setStatusFilter('all')}
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 2, 
                  p: 1.5, 
                  borderRadius: 2, 
                  bgcolor: statusFilter === 'all' ? '#007B8A' : 'transparent',
                  color: statusFilter === 'all' ? 'white' : '#6B7280',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: statusFilter === 'all' ? '#007B8A' : '#F3F4F6', color: statusFilter === 'all' ? 'white' : '#374151' },
                  mb: 1
                }}>
                <ListIcon sx={{ fontSize: 20 }} />
                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
                  Tous les templates
                </Typography>
              </Box>
              
              <Box 
                onClick={() => {
                  // Filter by favorites
                  const newFilter = statusFilter === 'favorites' ? 'all' : 'favorites';
                  setStatusFilter(newFilter);
                }}
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 2, 
                  p: 1.5, 
                  borderRadius: 2, 
                  bgcolor: statusFilter === 'favorites' ? '#007B8A' : 'transparent',
                  color: statusFilter === 'favorites' ? 'white' : '#6B7280',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: statusFilter === 'favorites' ? '#007B8A' : '#F3F4F6', color: statusFilter === 'favorites' ? 'white' : '#374151' },
                  mb: 1
                }}>
                <StarIcon sx={{ fontSize: 20 }} />
                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
                  Favoris
                </Typography>
              </Box>

              {/* Date Filter */}
              <Box 
                onClick={(e) => {
                  if (statusFilter === 'date') {
                    // Si le filtre date est déjà sélectionné, ouvrir le sélecteur
                    setDatePickerOpen(true);
                  } else {
                    // Sinon, activer le filtre date et ouvrir le sélecteur
                    setStatusFilter('date');
                    setDatePickerOpen(true);
                  }
                }}
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 2, 
                  p: 1.5, 
                  borderRadius: 2, 
                  bgcolor: statusFilter === 'date' ? '#007B8A' : 'transparent',
                  color: statusFilter === 'date' ? 'white' : '#6B7280',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: statusFilter === 'date' ? '#007B8A' : '#F3F4F6', color: statusFilter === 'date' ? 'white' : '#374151' },
                  mb: 1
                }}>
                <CalendarTodayIcon sx={{ fontSize: 20 }} />
                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
                  {statusFilter === 'date' && (startDate || endDate) ? `${getDateFilterLabel()}` : 'Filtrer par date'}
                </Typography>
              </Box>
              
              <Box 
                onClick={() => {
                  // Filter by archived
                  const newFilter = statusFilter === 'archived' ? 'all' : 'archived';
                  setStatusFilter(newFilter);
                }}
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 2, 
                  p: 1.5, 
                  borderRadius: 2, 
                  bgcolor: statusFilter === 'archived' ? '#007B8A' : 'transparent',
                  color: statusFilter === 'archived' ? 'white' : '#6B7280',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: statusFilter === 'archived' ? '#007B8A' : '#F3F4F6', color: statusFilter === 'archived' ? 'white' : '#374151' }
                }}>
                <ArchiveIcon sx={{ fontSize: 20 }} />
                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
                  Archivés
                </Typography>
              </Box>
              
              {/* Status Filters */}
              <Box sx={{ mt: 3, pt: 3, borderTop: '1px solid #E5E7EB' }}>
                <Typography sx={{ 
                  fontSize: '0.75rem', 
                  fontWeight: 600, 
                  textTransform: 'uppercase', 
                  color: '#9CA3AF',
                  mb: 2,
                  px: 1.5
                }}>
                  Statuts
                </Typography>
                
                <Box 
                  onClick={() => {
                    const newFilter = statusFilter === 'published' ? 'all' : 'published';
                    setStatusFilter(newFilter);
                  }}
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 1.5, 
                    borderRadius: 2, 
                    bgcolor: statusFilter === 'published' ? '#007B8A' : 'transparent',
                    color: statusFilter === 'published' ? 'white' : '#6B7280',
                    cursor: 'pointer',
                    '&:hover': { bgcolor: statusFilter === 'published' ? '#007B8A' : '#F3F4F6', color: statusFilter === 'published' ? 'white' : '#374151' },
                    mb: 1
                  }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#10B981' }} />
                  <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
                    Publié
                  </Typography>
                </Box>
                
                <Box 
                  onClick={() => {
                    const newFilter = statusFilter === 'draft' ? 'all' : 'draft';
                    setStatusFilter(newFilter);
                  }}
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2, 
                    p: 1.5, 
                    borderRadius: 2, 
                    bgcolor: statusFilter === 'draft' ? '#007B8A' : 'transparent',
                    color: statusFilter === 'draft' ? 'white' : '#6B7280',
                    cursor: 'pointer',
                    '&:hover': { bgcolor: statusFilter === 'draft' ? '#007B8A' : '#F3F4F6', color: statusFilter === 'draft' ? 'white' : '#374151' },
                    mb: 1
                  }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#F59E0B' }} />
                  <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
                    Brouillon
                  </Typography>
                </Box>

                {/* Divider */}
                <Box sx={{ height: 1, bgcolor: '#E5E7EB', my: 2 }} />
              </Box>
            </Box>
          </Paper>
        )}
        
        <Box sx={{ display: 'flex', flex: 1, gap: 0, overflow: 'hidden' }}>
          {/* Column 1: Email List - 2/5 width */}
          <Paper sx={{ width: '40%', minWidth: 360, borderRadius: 0, borderRight: '1px solid #E5E7EB', display: interfaceHidden ? 'none' : 'flex', flexDirection: 'column', p: 3 }}>
          {/* Header with toggle and title */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, px: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
              <Tooltip title={subMenuCollapsed ? "Afficher les filtres" : "Masquer les filtres"} arrow>
                <IconButton
                  data-tourid="sidebar-toggle"
                  onClick={() => setSubMenuCollapsed(!subMenuCollapsed)}
                  size="small"
                  sx={{
                    color: '#6B7280',
                    border: '1px solid #E5E7EB',
                    borderRadius: '50%',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                    '&:hover': { bgcolor: '#F9FAFB' },
                    p: 0.75
                  }}
                >
                  {subMenuCollapsed ? <ChevronRightIcon sx={{ fontSize: 20 }} /> : <ChevronLeftIcon sx={{ fontSize: 20 }} />}
                </IconButton>
              </Tooltip>
              <Typography variant="h6" sx={{ 
                fontWeight: 'bold', 
                fontSize: '1rem', 
                color: '#1F2937'
              }}>
                Templates Email
              </Typography>
              <Tooltip title="Guide de démarrage">
                <IconButton 
                  size="small" 
                  onClick={() => {
                    // Open sidebar before starting tour to ensure elements are in DOM
                    if (subMenuCollapsed) {
                      setSubMenuCollapsed(false);
                      // Wait for sidebar to render before starting tour
                      setTimeout(() => setRunTour(true), 500);
                    } else {
                      setRunTour(true);
                    }
                  }}
                  sx={{ 
                    color: '#007B8A',
                    '&:hover': { backgroundColor: 'rgba(0, 123, 138, 0.08)' },
                    p: 0.5,
                    ml: 1
                  }}
                >
                  <HelpOutlineIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            </Box>
            <Tooltip title="Nouveau Template" arrow>
              <IconButton
                data-tourid="new-template-button"
                onClick={() => {
                  setAssistantMode('new');
                  setInterfaceHidden(true);
                  setAssistantOpen(true);
                }}
                size="small"
                sx={{
                  color: '#6B7280',
                  '&:hover': {
                    color: '#007B8A',
                    bgcolor: '#F3F4F6'
                  },
                  p: 0.75
                }}
              >
                <AddIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Search and Filters */}
          <Box sx={{ mb: 2, px: 2 }}>
            <TextField
              data-tourid="search-templates"
              fullWidth
              placeholder={"Rechercher un template..."}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: '#9CA3AF' }} />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />
            
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', fontWeight: 500 }}>
                  Trier par:
                </Typography>
                <Box sx={{ position: 'relative' }} data-tourid="sort-templates">
                  <Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    size="small"
                    sx={{
                      fontSize: '0.75rem',
                      bgcolor: '#F9FAFB',
                      border: '1px solid #D1D5DB',
                      borderRadius: 2,
                      minWidth: 120,
                      height: 32,
                      '& .MuiSelect-select': {
                        py: 0.75,
                        px: 1.5,
                        pr: 4,
                        fontSize: '0.75rem',
                        fontWeight: 500,
                        color: '#374151'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                      },
                      '&:hover': {
                        bgcolor: 'white'
                      },
                      '& .MuiSelect-icon': {
                        color: '#6B7280',
                        fontSize: 16
                      }
                    }}
                  >
                    <MenuItem value="name" sx={{ fontSize: '0.75rem' }}>Nom</MenuItem>
                    <MenuItem value="modified" sx={{ fontSize: '0.75rem' }}>Date de modification</MenuItem>
                    <MenuItem value="created" sx={{ fontSize: '0.75rem' }}>Date de création</MenuItem>
                  </Select>
                </Box>
                
              </Box>
              <Tooltip title={sortDirection === 'asc' ? 'Ordre croissant' : 'Ordre décroissant'} arrow>
                <IconButton
                  onClick={() => setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')}
                  size="small"
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 2,
                    bgcolor: '#F9FAFB',
                    border: '1px solid #D1D5DB',
                    color: '#6B7280',
                    '&:hover': {
                      bgcolor: '#F3F4F6',
                      color: '#374151'
                    }
                  }}
                >
                  {sortDirection === 'asc' ? 
                    <ArrowUpwardIcon sx={{ fontSize: 16 }} /> : 
                    <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                  }
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {/* Calendar Date Range Picker Dialog - Simplified */}
          <Dialog
            open={datePickerOpen}
            onClose={() => {
              // Comportement identique au bouton "Effacer"
              setStartDate(null);
              setEndDate(null);
              setStatusFilter('all');
              setSelectingRange(false);
              // Reset calendar to current month
              const now = new Date();
              setCurrentCalendarDate({ year: now.getFullYear(), month: now.getMonth() + 1 });
              // Fermer la modale après effacement
              setDatePickerOpen(false);
            }}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 2,
                overflow: 'hidden'
              }
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              {/* Header */}
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                p: 3, 
                borderBottom: '1px solid #E5E7EB',
                flexShrink: 0
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="h5" fontWeight={600} color="text.primary">
                  Filtrer par période
                </Typography>
                  {startDate || endDate ? (
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 1,
                      px: 2,
                      py: 0.5,
                      bgcolor: '#E3F2FD',
                      borderRadius: 1,
                      border: '1px solid #2196F3'
                    }}>
                      <Typography variant="body2" color="#1976d2" fontWeight={500}>
                        {startDate && !endDate && `À partir du ${new Date(startDate).toLocaleDateString('fr-FR')}`}
                        {!startDate && endDate && `Jusqu'au ${new Date(endDate).toLocaleDateString('fr-FR')}`}
                        {startDate && endDate && `Du ${new Date(startDate).toLocaleDateString('fr-FR')} au ${new Date(endDate).toLocaleDateString('fr-FR')}`}
                      </Typography>
                      {startDate && endDate && (
                        <Typography variant="caption" color="#1976d2" sx={{ 
                          bgcolor: '#1976d2', 
                          color: 'white', 
                          px: 1, 
                          py: 0.25, 
                          borderRadius: 0.5,
                          fontWeight: 600
                        }}>
                          {Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1} jour{Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1 > 1 ? 's' : ''}
                        </Typography>
                      )}
                    </Box>
                  ) : null}
                </Box>
                <IconButton
                  onClick={() => {
                    // Comportement identique au bouton "Effacer"
                    setStartDate(null);
                    setEndDate(null);
                    setStatusFilter('all');
                    setSelectingRange(false);
                    // Reset calendar to current month
                    const now = new Date();
                    setCurrentCalendarDate({ year: now.getFullYear(), month: now.getMonth() + 1 });
                    // Fermer la modale après effacement
                    setDatePickerOpen(false);
                  }}
                  sx={{ color: '#6B7280', '&:hover': { color: '#374151' } }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>

              {/* Calendar Content */}
              <Box sx={{ p: 4 }}>
                  {/* Calendar Navigation */}
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                      <IconButton 
                      size="medium" 
                        sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }}
                        onClick={() => handleCalendarNavigation('prev')}
                      >
                        <ChevronLeftIcon />
                      </IconButton>
                      
                      <Typography 
                      variant="h5" 
                        fontWeight={600} 
                        color="text.primary"
                        onClick={() => setMonthYearPickerOpen(true)}
                        sx={{ 
                          cursor: 'pointer',
                        px: 2,
                        py: 1,
                          borderRadius: 1,
                          '&:hover': { 
                            bgcolor: '#F3F4F6' 
                          }
                        }}
                      >
                        {new Date(currentCalendarDate.year, currentCalendarDate.month - 1).toLocaleDateString('fr-FR', { 
                          month: 'long', 
                          year: 'numeric' 
                        })}
                      </Typography>
                      
                      <IconButton 
                      size="medium" 
                        sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }}
                        onClick={() => handleCalendarNavigation('next')}
                      >
                        <ChevronRightIcon />
                      </IconButton>
                    </Box>
                    
                    {/* Days of week */}
                  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', mb: 2 }}>
                      {['DI', 'LU', 'MA', 'ME', 'JE', 'VE', 'SA'].map((day) => (
                      <Typography key={day} variant="subtitle2" color="text.secondary" sx={{ py: 1, textAlign: 'center', fontWeight: 600 }}>
                          {day}
                        </Typography>
                      ))}
                    </Box>
                    
                    {/* Calendar grid */}
                  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 1 }}>
                      {generateCalendarDays(currentCalendarDate.year, currentCalendarDate.month).map((dayData, index) => {
                        const dayDate = new Date(dayData.date);
                        const isInRange = isDateInRange(dayDate);
                        const isRangeStart = startDate && dayDate.toDateString() === startDate.toDateString();
                        const isRangeEnd = endDate && dayDate.toDateString() === endDate.toDateString();
                        
                        return (
                          <Box
                            key={index}
                            onClick={() => handleCalendarDateClick(dayDate)}
                            sx={{
                            p: 1,
                              textAlign: 'center',
                            fontSize: '0.875rem',
                              fontWeight: dayData.isToday ? 'bold' : 'normal',
                              color: dayData.isToday ? 'white' : 
                                     isRangeStart || isRangeEnd ? 'white' :
                                     isInRange ? '#007B8A' :
                                     dayData.isCurrentMonth ? 'text.primary' : 'text.secondary',
                              bgcolor: dayData.isToday ? '#0D9488' : 
                                      isRangeStart || isRangeEnd ? '#007B8A' :
                                      isInRange ? '#E6FFFA' : 'transparent',
                            borderRadius: (dayData.isToday || isRangeStart || isRangeEnd) ? '50%' : 1,
                            width: (dayData.isToday || isRangeStart || isRangeEnd) ? '36px' : 'auto',
                            height: (dayData.isToday || isRangeStart || isRangeEnd) ? '36px' : 'auto',
                            minHeight: '36px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              mx: 'auto',
                              cursor: 'pointer',
                            transition: 'all 0.2s ease',
                              '&:hover': {
                                bgcolor: dayData.isToday ? '#0D9488' :
                                         isRangeStart || isRangeEnd ? '#007B8A' :
                                       '#F0F9FF',
                              transform: 'scale(1.05)'
                              }
                            }}
                          >
                            {dayData.day}
                          </Box>
                        );
                      })}
                  </Box>
                </Box>
              </Box>

              {/* Month/Year Picker Dialog */}
              <Dialog
                open={monthYearPickerOpen}
                onClose={() => setMonthYearPickerOpen(false)}
                maxWidth="xs"
                PaperProps={{
                  sx: {
                    borderRadius: 2,
                    minWidth: 300
                  }
                }}
              >
                <Box sx={{ p: 3 }}>
                  <Typography variant="h6" fontWeight={600} color="text.primary" sx={{ mb: 3, textAlign: 'center' }}>
                    Sélectionner le mois et l'année
                  </Typography>
                  
                  {/* Year Selection */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight={600} color="text.primary" sx={{ mb: 1 }}>
                      Année
                    </Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
                      {Array.from({ length: 10 }, (_, i) => {
                        const year = new Date().getFullYear() - 5 + i;
                        return (
                          <Button
                            key={year}
                            variant={currentCalendarDate.year === year ? 'contained' : 'outlined'}
                            size="small"
                            onClick={() => handleMonthYearChange(year, currentCalendarDate.month)}
                            sx={{
                              minWidth: 'auto',
                              borderRadius: 1,
                              bgcolor: currentCalendarDate.year === year ? '#007B8A' : 'transparent',
                              '&:hover': {
                                bgcolor: currentCalendarDate.year === year ? '#006B75' : '#F0F9FF'
                              }
                            }}
                          >
                            {year}
                          </Button>
                        );
                      })}
                    </Box>
                  </Box>
                  
                  {/* Month Selection */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" fontWeight={600} color="text.primary" sx={{ mb: 1 }}>
                      Mois
                    </Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
                      {[
                        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
                      ].map((monthName, index) => {
                        const monthNumber = index + 1;
                        return (
                          <Button
                            key={monthNumber}
                            variant={currentCalendarDate.month === monthNumber ? 'contained' : 'outlined'}
                            size="small"
                            onClick={() => handleMonthYearChange(currentCalendarDate.year, monthNumber)}
                            sx={{
                              minWidth: 'auto',
                              borderRadius: 1,
                              fontSize: '0.75rem',
                              bgcolor: currentCalendarDate.month === monthNumber ? '#007B8A' : 'transparent',
                              '&:hover': {
                                bgcolor: currentCalendarDate.month === monthNumber ? '#006B75' : '#F0F9FF'
                              }
                            }}
                          >
                            {monthName.substring(0, 3)}
                          </Button>
                        );
                      })}
                    </Box>
                  </Box>
                  
                  {/* Actions */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button
                      onClick={() => setMonthYearPickerOpen(false)}
                      variant="outlined"
                      sx={{ borderRadius: 2 }}
                    >
                      Annuler
                    </Button>
                    <Button
                      onClick={() => {
                        const now = new Date();
                        handleMonthYearChange(now.getFullYear(), now.getMonth() + 1);
                      }}
                      variant="contained"
                      sx={{ 
                        bgcolor: '#007B8A', 
                        '&:hover': { bgcolor: '#006B75' },
                        borderRadius: 2
                      }}
                    >
                      Aujourd'hui
                    </Button>
                  </Box>
                </Box>
              </Dialog>

              {/* Footer Actions */}
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                p: 3, 
                borderTop: '1px solid #E5E7EB',
                flexShrink: 0
              }}>
                <Button 
                  onClick={() => {
                    setStartDate(null);
                    setEndDate(null);
                    setStatusFilter('all');
                    setSelectingRange(false);
                    // Reset calendar to current month
                    const now = new Date();
                    setCurrentCalendarDate({ year: now.getFullYear(), month: now.getMonth() + 1 });
                    // Fermer la modale après effacement
                    setDatePickerOpen(false);
                  }}
                  color="error"
                  variant="outlined"
                  sx={{ borderRadius: 2 }}
                >
                  Effacer
                </Button>
                
                  <Button 
                    onClick={() => {
                      // Set status filter to 'date' when applying the filter
                      if (startDate || endDate) {
                        setStatusFilter('date');
                      }
                      setDatePickerOpen(false);
                    }}
                    variant="contained"
                    disabled={!startDate && !endDate}
                    sx={{ 
                      bgcolor: '#007B8A', 
                      '&:hover': { bgcolor: '#006B75' },
                      borderRadius: 2,
                      px: 3
                    }}
                  >
                    Appliquer le filtre
                  </Button>
              </Box>
            </Box>
          </Dialog>

          {/* Email List */}
          <Box sx={{ flex: 1, overflow: 'auto', pl: 2, pr: 0 }} data-tourid="templates-list">
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                <CircularProgress size={24} />
              </Box>
            ) : error ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography color="error" sx={{ mb: 2 }}>
                {error}
              </Typography>
                <Button 
                  onClick={() => setRefreshKey(prev => prev + 1)}
                  variant="outlined"
                  size="small"
                >
                  Réessayer
                </Button>
              </Box>
            ) : emails.length === 0 ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200, color: '#6B7280' }}>
                <Typography>Aucun email à afficher</Typography>
              </Box>
            ) : (
              <List sx={{ p: 0 }}>
                {paginatedEmails.map((email) => (
                  <ListItemButton
                    key={email.id}
                    selected={selectedEmailId === email.id}
                    onClick={() => handleEmailSelect(email.id)}
                    sx={{
                      borderRadius: 2,
                      mb: 0.5,
                      p: 1.2,
                      bgcolor: selectedEmailId === email.id ? '#F0FDFA' : 'transparent',
                      position: 'relative',
                      '&:hover': {
                        bgcolor: selectedEmailId === email.id ? '#F0FDFA' : '#F9FAFB',
                        '& .hover-actions': {
                          opacity: 1,
                        },
                      },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, minWidth: 0, pr: 2 }}>
                        {/* Favorite Toggle */}
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleFavorite(email.id);
                          }}
                          sx={{
                            color: isFavorite(email.id) ? '#F59E0B' : '#9CA3AF',
                            '&:hover': { color: '#F59E0B' },
                            p: 0.5
                          }}
                        >
                          {isFavorite(email.id) ? 
                            <StarIcon sx={{ fontSize: 20 }} /> : 
                            <StarBorderIcon sx={{ fontSize: 20 }} />
                          }
                        </IconButton>
                        
                        {/* Email Name */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, minWidth: 0 }}>
                          <Typography sx={{ 
                            fontWeight: 400,
                            fontSize: '0.875rem', 
                            color: selectedEmailId === email.id ? '#0F766E' : '#1F2937',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}>
                            {email.name}
                          </Typography>
                          
                          {/* A/B Test Indicator */}
                          {(email.variantChildren?.length > 0 || email.variantParent) && (
                            <Tooltip title={onGoingAbTests.includes(email.id) ? "A/B Test en cours" : "A/B Test terminé"} arrow>
                              <IconButton
                                size="small"
                                
                                sx={{
                                  color: onGoingAbTests.includes(email.id) ? 'success.main' : 'grey.600',
                                  border: '1px solid',
                                  borderColor: onGoingAbTests.includes(email.id) ? 'success.light' : 'grey.400',
                                  backgroundColor: 'transparent',
                                  width: 24,
                                  height: 24,
                                  '&:hover': {
                                    backgroundColor: onGoingAbTests.includes(email.id) ? 'rgba(46, 125, 50, 0.04)' : 'rgba(158, 158, 158, 0.04)',
                                  },
                                }}
                              >
                                <ScienceIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </Box>
                      
                      {/* Status Indicator */}
                      <Box
                        title={email.isPublished ? 'Publié' : 'Brouillon'}
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          bgcolor: email.isPublished ? '#10B981' : '#F59E0B',
                          flexShrink: 0
                        }}
                      />
                    </Box>
                    
                    {/* Hover Actions */}
                    <Box
                      className="hover-actions"
                      sx={{
                        position: 'absolute',
                        bgcolor: 'white',
                        borderRadius: '5px',
                        right: 80,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        opacity: 0,
                        transition: 'opacity 0.2s ease-in-out',
                      }}
                    >
                      <Tooltip title={email.isPublished ? "Désactiver" : "Activer"} arrow>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleTogglePublishStatus(email.id, !email.isPublished);
                          }}
                          sx={{
                            /*bgcolor: 'white',
                            border: '1px solid #E5E7EB',*/
                            p:0.5,
                            color: email.isPublished ? '#B0B0B0' : '#B0B0B0',
                            '&:hover': { color: email.isPublished ? '#059669' : '#374151' },
                            /*width: 24,
                            height: 24,*/
                          }}
                        >
                          {email.isPublished ? 
                            <ToggleOffOutlinedIcon sx={{ fontSize: 16 }} /> : 
                            <ToggleOnOutlinedIcon sx={{ fontSize: 16 }} />
                          }
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Cloner" arrow>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDuplicateClick(email);
                          }}
                          sx={{ p: 0.5, color: '#B0B0B0', '&:hover': { color: '#007B8A' } }}
                        >
                          <ContentCopyIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={isEmailArchived(email.id) ? "Restaurer" : "Archiver"} arrow>
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            if (isEmailArchived(email.id)) {
                              handleRestoreEmail(email.id);
                            } else {
                              handleArchiveEmail(email.id);
                            }
                          }}
                          sx={{ 
                            p: 0.5, 
                            color: '#B0B0B0', 
                            '&:hover': { 
                              color: isEmailArchived(email.id) ? '#10B981' : '#F59E0B' 
                            } 
                          }}
                        >
                          {isEmailArchived(email.id) ? (
                            <UnarchiveIcon sx={{ fontSize: 16 }} />
                          ) : (
                            <ArchiveIcon sx={{ fontSize: 16 }} />
                          )}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={isEmailInCampaign(email.id) ? "Cet email est utilisé dans une campagne et ne peut pas être supprimé." : "Supprimer"} arrow>
                        <span>
                          <IconButton
                            size="small"
                            disabled={isEmailInCampaign(email.id)}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteClick(email);
                            }}
                            sx={{ 
                              p: 0.5, 
                              color: '#B0B0B0', 
                              '&:hover': { color: '#EF4444' },
                              // Appliquer le style de curseur non autorisé lorsque le bouton est désactivé
                              cursor: isEmailInCampaign(email.id) ? 'not-allowed' : 'pointer'
                            }}
                          >
                            <DeleteIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </Box>
                  </ListItemButton>
                ))}
              </List>
            )}
          </Box>

          {/* Pagination with controls - Modern design */}
          {!loading && emails.length > 0 && (
          <Box data-tourid="pagination" sx={{ 
            pt: 2, 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            px: 2, // 16px padding
            borderTop: '1px solid #F3F4F6',
            mt: 2
          }}>
            {/* Left: Compact page size selector */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(e.target.value);
                  setPage(1);
                }}
                variant="outlined"
                size="small"
                sx={{
                  minWidth: 70,
                  height: 36,
                  bgcolor: 'white',
                  border: '1px solid #E5E7EB',
                  borderRadius: 1,
                  '& .MuiSelect-select': {
                    py: 1,
                    px: 1.5,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    color: '#374151'
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none'
                  },
                  '&:hover': {
                    bgcolor: '#F9FAFB'
                  },
                  '& .MuiSelect-icon': {
                    color: '#6B7280'
                  }
                }}
              >
                {[5, 10, 15, 20, 25, 30, 50, 100].map((size) => (
                  <MenuItem key={size} value={size} sx={{ fontSize: '0.875rem' }}>
                    {size}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {/* Center: Modern Pagination */}
            {pageCount > 1 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <IconButton
                  size="small"
                  disabled={page === 1}
                  onClick={() => goToPage(page - 1)}
                  sx={{
                    width: 32,
                    height: 32,
                    border: '1px solid #E5E7EB',
                    bgcolor: 'white',
                    color: page === 1 ? '#D1D5DB' : '#6B7280',
                    '&:hover': {
                      bgcolor: page === 1 ? 'white' : '#F9FAFB'
                    },
                    '&:disabled': {
                      bgcolor: 'white',
                      border: '1px solid #F3F4F6'
                    }
                  }}
                >
                  <ChevronLeftIcon sx={{ fontSize: 16 }} />
                </IconButton>
                
                {/* Page numbers */}
                {Array.from({ length: Math.min(pageCount, 5) }, (_, i) => {
                  let pageNum;
                  if (pageCount <= 5) {
                    pageNum = i + 1;
                  } else if (page <= 3) {
                    pageNum = i + 1;
                  } else if (page >= pageCount - 2) {
                    pageNum = pageCount - 4 + i;
                  } else {
                    pageNum = page - 2 + i;
                  }
                  
                  return (
                    <IconButton
                      key={pageNum}
                      size="small"
                      onClick={() => goToPage(pageNum)}
                      sx={{
                        width: 32,
                        height: 32,
                        border: page === pageNum ? 'none' : '1px solid #E5E7EB',
                        bgcolor: page === pageNum ? '#007B8A' : 'white',
                        color: page === pageNum ? 'white' : '#6B7280',
                        fontSize: '0.875rem',
                        fontWeight: page === pageNum ? 600 : 500,
                        '&:hover': {
                          bgcolor: page === pageNum ? '#006064' : '#F9FAFB'
                        }
                      }}
                    >
                      {pageNum}
                    </IconButton>
                  );
                })}
                
                <IconButton
                  size="small"
                  disabled={page === pageCount}
                  onClick={() => goToPage(page + 1)}
                  sx={{
                    width: 32,
                    height: 32,
                    border: '1px solid #E5E7EB',
                    bgcolor: 'white',
                    color: page === pageCount ? '#D1D5DB' : '#6B7280',
                    '&:hover': {
                      bgcolor: page === pageCount ? 'white' : '#F9FAFB'
                    },
                    '&:disabled': {
                      bgcolor: 'white',
                      border: '1px solid #F3F4F6'
                    }
                  }}
                >
                  <ChevronRightIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Box>
            )}

            {/* Right: Total count */}
            <Typography variant="body2" sx={{ 
              fontSize: '0.875rem',
              color: '#6B7280',
              fontWeight: 500
            }}>
              {totalEmails} email{totalEmails !== 1 ? 's' : ''}
            </Typography>
          </Box>
          )}
          </Paper>

          {/* Column 2: Preview + Tabs - 3/5 width */}
          <Box sx={{ width: interfaceHidden ? '100%' : '60%', overflow: 'auto', bgcolor: '#FAFAFA', borderLeft: '1px solid #E5E7EB' }} data-tourid="email-details">
          {loading && selectedEmailId ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress size={32} />
            </Box>
          ) : selectedEmailDetails ? (
            <>
              {/* Header avec titre et actions */}
              <Box sx={{ p: 3, borderBottom: '1px solid #E5E7EB', bgcolor: 'white' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
                  <Box>
                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#1F2937', mb: 2,fontSize: '1.25rem' }}>
                      {selectedEmailDetails.name}
                    </Typography>
                    {/* Barre d'outils d'actions */}
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 1, 
                      border: '1px solid #E5E7EB', 
                      borderRadius: 2, 
                      p: 1, 
                      bgcolor: '#F9FAFB',
                      width: 'fit-content'
                    }}>
                      <Tooltip title="Voir le code HTML" arrow>
                        <IconButton onClick={handleOpenHtmlModal} size="small" sx={{ p: 1, color: '#6B7280', '&:hover': { bgcolor: '#E5E7EB' } }}>
                          <CodeIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Voir la version texte" arrow>
                        <IconButton onClick={handleOpenTextModal} size="small" sx={{ p: 1, color: '#6B7280', '&:hover': { bgcolor: '#E5E7EB' } }}>
                          <TextFieldsIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                      </Tooltip>
                      <Box sx={{ width: 1, height: 24, bgcolor: '#D1D5DB', mx: 0.5 }} />
                      <Tooltip title="Prévisualiser sur multi-clients" arrow>
                        <IconButton onClick={openMailPreviewModal} size="small" sx={{ p: 1, color: '#6B7280', '&:hover': { bgcolor: '#E5E7EB' } }}>
                          <MonitorIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Analyse & Spam Check" arrow>
                        <IconButton size="small" sx={{ p: 1, color: '#6B7280', '&:hover': { bgcolor: '#E5E7EB' } }} onClick={openSpamModal}>
                          <SecurityIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                      </Tooltip>
                      <Box sx={{ width: 1, height: 24, bgcolor: '#D1D5DB', mx: 0.5 }} />
                      <Tooltip title="Envoyer un test" arrow>
                        <IconButton onClick={openTestEmailModal} size="small" sx={{ p: 1, color: '#6B7280', '&:hover': { bgcolor: '#E5E7EB' } }}>
                          <SendIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Tooltip title="Modifier dans l'éditeur" arrow>
                      <IconButton
                        size="small"
                        onClick={handleOpenAssistantEdit}
                        sx={{
                          p: 1,
                          border: '1px solid #E5E7EB',
                          color: '#6B7280',
                          '&:hover': { bgcolor: '#F3F4F6' }
                        }}
                      >
                        <EditIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Plus d'options" arrow>
                      <IconButton
                        size="small"
                        onClick={handleActionsMenuOpen}
                        sx={{
                          p: 1,
                          color: '#6B7280',
                          '&:hover': { bgcolor: '#F3F4F6' }
                        }}
                      >
                        <MoreVertIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>

              {/* Aperçu de l'email */}
              <Box sx={{ p: 3, bgcolor: 'white', borderBottom: '1px solid #E5E7EB' }}>
                <Paper sx={{ border: '1px solid #E5E7EB', borderRadius: 2, overflow: 'hidden', boxShadow: 1 }}>
                  {/* Sélecteur de vue Desktop/Mobile */}
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    p: 1, 
                    borderBottom: '1px solid #E5E7EB', 
                    bgcolor: '#F9FAFB' 
                  }}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 0.5, 
                      border: '1px solid #D1D5DB', 
                      borderRadius: 2, 
                      p: 0.5,
                      bgcolor: 'white',
                      fontSize: '0.75rem',
                      fontWeight: 500
                    }}>
                      <Button
                        variant={previewMode === 'desktop' ? 'contained' : 'text'}
                        size="small"
                        onClick={() => setPreviewMode('desktop')}
                        title="Vue Ordinateur"
                        sx={{
                          minWidth: 'auto',
                          p: 1,
                          bgcolor: previewMode === 'desktop' ? '#007B8A' : 'transparent',
                          color: previewMode === 'desktop' ? 'white' : '#6B7280',
                          '&:hover': {
                            bgcolor: previewMode === 'desktop' ? '#006B7A' : '#F3F4F6'
                          }
                        }}
                      >
                        <MonitorIcon sx={{ fontSize: 20 }} />
                      </Button>
                      <Button
                        variant={previewMode === 'mobile' ? 'contained' : 'text'}
                        size="small"
                        onClick={() => setPreviewMode('mobile')}
                        title="Vue Mobile"
                        sx={{
                          minWidth: 'auto',
                          p: 1,
                          bgcolor: previewMode === 'mobile' ? '#007B8A' : 'transparent',
                          color: previewMode === 'mobile' ? 'white' : '#6B7280',
                          '&:hover': {
                            bgcolor: previewMode === 'mobile' ? '#006B7A' : '#F3F4F6'
                          }
                        }}
                      >
                        <SmartphoneIcon sx={{ fontSize: 20 }} />
                      </Button>
                    </Box>
                  </Box>
                  
                  {/* Conteneur pour l'aperçu */}
                  <Box sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#F3F4F6', minHeight: 300 }}>
                    {previewMode === 'desktop' ? (
                      <Box sx={{ 
                        width: '100%', 
                        height: '60vh', 
                        bgcolor: 'white', 
                        boxShadow: 2, 
                        borderRadius: 1,
                        overflow: 'hidden'
                      }}>
                        {selectedEmailDetails ? (
                          <iframe
                            title="Desktop Preview"
                            srcDoc={(selectedEmailDetails.customHtml || selectedEmailDetails.html || '').replace(/<a/g, '<a target="_blank"')}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                          />
                        ) : (
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <Typography>Sélectionnez un email pour voir l'aperçu.</Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box sx={{ 
                        width: 375, 
                        height: 667, 
                        bgcolor: 'white', 
                        boxShadow: 4, 
                        borderRadius: '40px', 
                        border: '12px solid #1F2937', 
                        display: 'flex', 
                        flexDirection: 'column',
                        mx: 'auto',
                        overflow: 'hidden'
                      }}>
                        {selectedEmailDetails ? (
                          <iframe
                            title="Mobile Preview"
                            srcDoc={(selectedEmailDetails.customHtml || selectedEmailDetails.html || '').replace(/<a/g, '<a target="_blank"')}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                          />
                        ) : (
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <Typography>Sélectionnez un email pour voir l'aperçu.</Typography>
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Box>

              {/* Navigation des onglets */}
              <Box sx={{ bgcolor: 'white', borderBottom: '1px solid #E5E7EB' }} data-tourid="email-tabs">
                <Box sx={{ display: 'flex', px: 3, gap: 4 }}>
                   {[ 
                     'Analyse & IA', 
                     'Contacts', 
                     'Performance des Clics', 
                     'A/B Test', 
                     'Configuration' 
                   ].map((tab, index) => (
                    <Box
                      key={tab}
                      onClick={() => setTabValue(index)}
                      sx={{
                        py: 2,
                        px: 1,
                        cursor: 'pointer',
                        borderBottom: tabValue === index ? '2px solid #007B8A' : '2px solid transparent',
                        color: tabValue === index ? '#007B8A' : '#6B7280',
                        fontWeight: tabValue === index ? 600 : 500,
                        fontSize: '0.875rem',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                          color: '#374151'
                        }
                      }}
                    >
                      {tab}
                    </Box>
                  ))}
                </Box>
              </Box>

              {/* Tab Content */}
              <Box sx={{ flex: 1, overflow: 'auto' }}>
                {/* Onglet Analyse & IA - FONCTIONNEL */}
                {tabValue === getTabIndex('Analyse & IA') && (
                  <Box sx={{ p: 3, space: 3 }}>
                    {!selectedEmailId ? (
                      <Box sx={{ textAlign: 'center', py: 8 }}>
                        <TrendingUpIcon sx={{ fontSize: 48, color: '#9CA3AF', mb: 2 }} />
                        <Typography variant="h6" sx={{ color: '#6B7280', mb: 1 }}>
                          Sélectionnez un email pour voir son analyse
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#9CA3AF' }}>
                          Choisissez un email dans la liste pour afficher ses statistiques détaillées et son analyse IA
                        </Typography>
                      </Box>
                    ) : (
                      <>
                    {/* Statistiques de l'email */}
                        <Paper sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, boxShadow: 1, mb: 3 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                        <TrendingUpIcon sx={{ fontSize: 20, color: '#9CA3AF' }} />
                        <Typography sx={{ fontWeight: 600, fontSize: '1rem', color: '#1F2937' }}>
                          Statistiques de l'email
                        </Typography>
                            {emailStatsLoading && (
                              <CircularProgress size={16} sx={{ ml: 1 }} />
                            )}
                      </Box>
                          
                          {emailStatsError ? (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                              <Typography variant="body2" sx={{ color: '#DC2626', mb: 2 }}>
                                {emailStatsError}
                              </Typography>
                              <Button 
                                onClick={() => fetchEmailStats(selectedEmailId)}
                                variant="outlined"
                                size="small"
                              >
                                Réessayer
                              </Button>
                            </Box>
                          ) : emailStatsLoading ? (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                              <CircularProgress size={32} />
                              <Typography variant="body2" sx={{ color: '#6B7280', mt: 2 }}>
                                Chargement des statistiques...
                              </Typography>
                            </Box>
                          ) : emailStats ? (
                      <Grid container spacing={3}>
                        <Grid item xs={6} lg={3}>
                          <Box sx={{ textAlign: 'left' }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', mb: 0.5 }}>
                              Destinataires
                            </Typography>
                            <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, color: '#1F2937' }}>
                                    {emailStats.recipients?.toLocaleString() || '0'}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                          <Box sx={{ textAlign: 'left' }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', mb: 0.5 }}>
                              Taux d'Ouverture
                            </Typography>
                            <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, color: '#1F2937' }}>
                                    {emailStats.open_rate || '0.00%'}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                          <Box sx={{ textAlign: 'left' }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', mb: 0.5 }}>
                              Taux de Clics
                            </Typography>
                            <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, color: '#1F2937' }}>
                                    {emailStats.click_rate || '0.00%'}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                          <Box sx={{ textAlign: 'left' }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', mb: 0.5 }}>
                              Taux de Conversion
                            </Typography>
                            <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, color: '#1F2937' }}>
                                    {emailStats.conversion_rate || '0.00%'}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                          <Box sx={{ textAlign: 'left', borderTop: '1px solid #E5E7EB', pt: 2 }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', mb: 0.5 }}>
                              Taux de Bounce
                            </Typography>
                            <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, color: '#DC2626' }}>
                                    {emailStats.bounce_rate || '0.00%'}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                          <Box sx={{ textAlign: 'left', borderTop: '1px solid #E5E7EB', pt: 2 }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', mb: 0.5 }}>
                              Taux d'Échec
                            </Typography>
                            <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, color: '#DC2626' }}>
                                    {emailStats.failure_rate || '0.00%'}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                          <Box sx={{ textAlign: 'left', borderTop: '1px solid #E5E7EB', pt: 2 }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', mb: 0.5 }}>
                              Taux de Désinscription
                            </Typography>
                            <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, color: '#DC2626' }}>
                                    {emailStats.unsubscribe_rate || '0.00%'}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                          <Box sx={{ textAlign: 'left', borderTop: '1px solid #E5E7EB', pt: 2 }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', mb: 0.5 }}>
                              Total des envois
                            </Typography>
                            <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, color: '#1F2937' }}>
                                    {emailStats.total_sent?.toLocaleString() || '0'}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                          ) : (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                              <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                Aucune donnée statistique disponible pour cet email
                              </Typography>
                            </Box>
                          )}
                    </Paper>

                    {/* Analyse par Qilinsa Amplify */}
                        <Paper sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, boxShadow: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                        <CpuIcon sx={{ fontSize: 20, color: '#9CA3AF' }} />
                        <Typography sx={{ fontWeight: 600, fontSize: '1rem', color: '#1F2937' }}>
                          Analyse par Qilinsa Amplify
                        </Typography>
                            {emailAnalysisLoading && (
                              <CircularProgress size={16} sx={{ ml: 1 }} />
                            )}
                      </Box>
                          
                          {emailAnalysisError ? (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                              <Typography variant="body2" sx={{ color: '#DC2626', mb: 2 }}>
                                {emailAnalysisError}
                              </Typography>
                              <Button 
                                onClick={() => fetchEmailAnalysis(selectedEmailId, selectedEmail?.name)}
                                variant="outlined"
                                size="small"
                              >
                                Réessayer l'analyse
                              </Button>
                            </Box>
                          ) : emailAnalysisLoading ? (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                              <CircularProgress size={32} />
                              <Typography variant="body2" sx={{ color: '#6B7280', mt: 2 }}>
                                Analyse en cours par l'IA...
                              </Typography>
                            </Box>
                          ) : emailAnalysis ? (
                      <Box sx={{ space: 2 }}>
                        <Box sx={{ 
                          borderRadius: 1.5, 
                          bgcolor: '#F9FAFB', 
                                p: 3,
                          mb: 2,
                          maxHeight: '70vh',
                          overflowY: 'auto'
                        }}>
                          {renderFormattedAnalysis(emailAnalysis.analysis)}
                          </Box>
                              
                              {emailAnalysis.stats_summary && (
                                <Box sx={{ 
                                  borderRadius: 1.5, 
                                  bgcolor: '#EFF6FF', 
                                  p: 2,
                                  mb: 2
                                }}>
                                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: '#1E40AF' }}>
                                    Résumé des performances :
                              </Typography>
                                  <Typography variant="body2" sx={{ color: '#1F2937' }}>
                                    {emailAnalysis.stats_summary.total_sent} envois • 
                                    {emailAnalysis.stats_summary.open_rate} d'ouverture • 
                                    {emailAnalysis.stats_summary.click_rate} de clics
                              </Typography>
                            </Box>
                              )}
                              
                              <Button
                                onClick={() => fetchEmailAnalysis(selectedEmailId, selectedEmail?.name)}
                                startIcon={<FlashOnIcon />}
                                disabled={emailAnalysisLoading}
                                sx={{
                                  bgcolor: '#FEF3C7',
                                  color: '#92400E',
                                  border: '1px solid #FDE68A',
                                  borderRadius: 1.5,
                                  px: 2,
                                  py: 1,
                                  fontSize: '0.875rem',
                                  fontWeight: 600,
                                  textTransform: 'none',
                                  '&:hover': {
                                    bgcolor: '#FDE68A'
                                  },
                                  '&:disabled': {
                                    bgcolor: '#F3F4F6',
                                    color: '#9CA3AF'
                                  }
                                }}
                              >
                                Régénérer l'analyse
                              </Button>
                          </Box>
                          ) : (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                              <Typography variant="body2" sx={{ color: '#6B7280', mb: 2 }}>
                                Aucune analyse disponible pour cet email
                              </Typography>
                        <Button
                                onClick={() => fetchEmailAnalysis(selectedEmailId, selectedEmail?.name)}
                          startIcon={<FlashOnIcon />}
                                disabled={!emailStats || emailAnalysisLoading}
                          sx={{
                            bgcolor: '#FEF3C7',
                            color: '#92400E',
                            border: '1px solid #FDE68A',
                            borderRadius: 1.5,
                            px: 2,
                            py: 1,
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            textTransform: 'none',
                            '&:hover': {
                              bgcolor: '#FDE68A'
                                  },
                                  '&:disabled': {
                                    bgcolor: '#F3F4F6',
                                    color: '#9CA3AF'
                            }
                          }}
                        >
                                Lancer l'analyse IA
                        </Button>
                      </Box>
                          )}
                    </Paper>
                      </>
                    )}
                  </Box>
                )}

                {tabValue === getTabIndex('Contacts') && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 3 }}>
                    <Paper sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                        <PeopleOutlineIcon sx={{ color: '#6B7280' }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1F2937', fontSize: '1rem' }}>
                          Contacts Ciblés
                        </Typography>
                      </Box>

                      {/* Controls */}
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2 }}>
                        <Typography variant="caption" sx={{ color: '#6B7280' }}>
                          Liste des contacts ayant reçu cet email.
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="caption" sx={{ color: '#6B7280' }}>Afficher</Typography>
                          <Select
                            value={contactsRowsPerPage}
                            onChange={handleContactsChangeRowsPerPage}
                            size="small"
                            sx={{ fontSize: '0.875rem', '.MuiSelect-select': { py: 0.5, px: 1 } }}
                          >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={25}>25</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                          </Select>
                          <Typography variant="caption" sx={{ color: '#6B7280' }}>par page</Typography>
                        </Box>
                      </Box>

                      {/* Table */}
                      <TableContainer>
                        <Table sx={{ minWidth: '100%' }}>
                          <TableHead>
                            <TableRow sx={{ borderBottom: '1px solid #E5E7EB' }}>
                              <TableCell sx={{ py: 2, fontWeight: 500, color: '#4B5563' }}>Nom</TableCell>
                              <TableCell sx={{ py: 2, fontWeight: 500, color: '#4B5563' }}>Email</TableCell>
                              <TableCell sx={{ py: 2, fontWeight: 500, color: '#4B5563' }}>Statut</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {contactsError ? (
                              <TableRow>
                                <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4 }}>
                                  <Typography variant="body2" sx={{ color: '#DC2626', mb: 2 }}>
                                    {contactsError}
                                  </Typography>
                                  <Button 
                                    onClick={() => fetchEmailContacts(selectedEmailId, contactsPage + 1, contactsRowsPerPage)}
                                    variant="outlined"
                                    size="small"
                                  >
                                    Réessayer
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ) : contactsLoading ? (
                              <TableRow>
                                <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4 }}>
                                  <CircularProgress size={24} />
                                  <Typography sx={{ mt: 1, color: '#6B7280' }}>Chargement des contacts...</Typography>
                                </TableCell>
                              </TableRow>
                            ) : paginatedContacts.length > 0 ? (
                              paginatedContacts.map((contact) => (
                              <TableRow 
                                key={contact.id} 
                                sx={{ 
                                  '&:last-child td, &:last-child th': { border: 0 },
                                  cursor: 'pointer',
                                  '&:hover': {
                                    backgroundColor: '#F9FAFB'
                                  }
                                }}
                                onClick={() => handleContactClick(contact)}
                              >
                                <TableCell sx={{ py: 2, fontWeight: 500, color: '#1F2937' }}>{contact.name}</TableCell>
                                <TableCell sx={{ py: 2, color: '#4B5563' }}>{contact.email}</TableCell>
                                <TableCell sx={{ py: 2 }}>
                                  <Chip 
                                    label={contact.status}
                                    size="small" 
                                    sx={{
                                      fontSize: '0.75rem',
                                      fontWeight: 500,
                                      bgcolor: 
                                        contact.status === 'Ouvert' ? '#DEF7EC' :
                                        contact.status === 'Échec' ? '#FFE4E6' :
                                        contact.status === 'Non ouvert' ? '#FEF3C7' :
                                        contact.status === 'Envoyé' ? '#E0E7FF' :
                                        '#F3F4F6',
                                      color: 
                                        contact.status === 'Ouvert' ? '#065F46' :
                                        contact.status === 'Échec' ? '#991B1B' :
                                        contact.status === 'Non ouvert' ? '#92400E' :
                                        contact.status === 'Envoyé' ? '#3730A3' :
                                        '#4B5563',
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4, color: '#6B7280' }}>
                                  {selectedEmailId ? 'Aucun contact trouvé pour cet email' : 'Sélectionnez un email pour voir les contacts'}
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {/* Pagination */}
                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#4B5563', fontSize: '0.875rem' }}>
                        <span>
                          {contactsLoading ? 'Chargement...' : `${contactsPage * contactsRowsPerPage + 1}-${Math.min((contactsPage + 1) * contactsRowsPerPage, contactsTotal)} sur ${contactsTotal}`}
                        </span>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                          <Button 
                            size="small" 
                            onClick={(e) => handleContactsChangePage(e, contactsPage - 1)} 
                            disabled={contactsPage === 0}
                            sx={{ textTransform: 'none' }}
                          >
                            Préc.
                          </Button>
                          <Button 
                            size="small" 
                            onClick={(e) => handleContactsChangePage(e, contactsPage + 1)} 
                            disabled={contactsPage >= Math.ceil(contactsTotal / contactsRowsPerPage) - 1}
                            sx={{ textTransform: 'none' }}
                          >
                            Suiv.
                          </Button>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>
                )}
                
                {tabValue === getTabIndex('Performance des Clics') && (
                  <Box sx={{ p: 3 }}>
                    <Paper sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)' }}>
                      {/* En-tête */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <AdsClickIcon sx={{ color: '#6B7280' }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1F2937' }}>
                          Performance des Clics par URL
                        </Typography>
                      </Box>

                      {/* Sous-en-tête et stats */}
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                        <Typography sx={{ fontSize: '0.875rem', color: '#4B5563' }}>
                          Analyse des liens les plus performants
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 4, fontSize: '0.875rem' }}>
                          <Typography>Total Clics: <Box component="span" sx={{ fontWeight: 'bold' }}>
                            {clickPerformanceLoading ? '...' : (clickPerformanceData?.total_clicks || 0)}
                          </Box></Typography>
                          <Typography>Clics Uniques: <Box component="span" sx={{ fontWeight: 'bold' }}>
                            {clickPerformanceLoading ? '...' : (clickPerformanceData?.total_unique_clicks || 0)}
                          </Box></Typography>
                        </Box>
                      </Box>

                      {/* Tableau */}
                      <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow sx={{ '& th': { borderBottom: '1px solid #E5E7EB', fontWeight: 500 } }}>
                              <TableCell>URL</TableCell>
                              <TableCell>Clics</TableCell>
                              <TableCell>Clics Uniques</TableCell>
                              <TableCell>Taux</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {clickPerformanceError ? (
                              <TableRow>
                                <TableCell colSpan={4} sx={{ textAlign: 'center', py: 4 }}>
                                  <Typography variant="body2" sx={{ color: '#DC2626', mb: 2 }}>
                                    {clickPerformanceError}
                                  </Typography>
                                  <Button 
                                    onClick={() => fetchClickPerformance(selectedEmailId)}
                                    variant="outlined"
                                    size="small"
                                  >
                                    Réessayer
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ) : clickPerformanceLoading ? (
                              <TableRow>
                                <TableCell colSpan={4} sx={{ textAlign: 'center', py: 4 }}>
                                  <CircularProgress size={24} />
                                  <Typography sx={{ mt: 1, color: '#6B7280' }}>Chargement des données...</Typography>
                                </TableCell>
                              </TableRow>
                            ) : clickPerformanceData?.click_data?.length > 0 ? (
                              clickPerformanceData.click_data.map((row, index) => (
                                <TableRow key={`${row.url}-${index}`} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                  <TableCell sx={{ color: '#2563EB', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    <a
                                      href={row.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: '#2563EB', textDecoration: 'none' }}
                                      
                                    >
                                      {row.url}
                                    </a>
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: 500 }}>{row.clicks}</TableCell>
                                  <TableCell>{row.unique_clicks}</TableCell>
                                  <TableCell sx={{ 
                                    color: getRateColor(row.rate), 
                                    fontWeight: 600,
                                    backgroundColor: `${getRateColor(row.rate)}15`, // Fond coloré léger
                                    borderRadius: 1,
                                    px: 1.5,
                                    py: 0.5
                                  }}>
                                    {row.rate}
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={4} sx={{ textAlign: 'center', py: 4, color: '#6B7280' }}>
                                  {selectedEmailId ? 'Aucune donnée de clics disponible pour cet email' : 'Sélectionnez un email pour voir les performances'}
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Box>
                )}

                {tabValue === getTabIndex('A/B Test') && (
                  <Box sx={{ p: 3 }}>
                    <Paper sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)' }}>
                      {/* En-tête */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <CallSplitIcon sx={{ color: '#6B7280' }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1F2937' }}>
                          Résultats A/B Test
                        </Typography>
                        
                      </Box>

                      {abTestLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                          <CircularProgress />
                          <Typography sx={{ ml: 2, color: '#6B7280' }}>Chargement des données A/B test...</Typography>
                        </Box>
                      ) : abTestError ? (
                        <Box sx={{ textAlign: 'center', py: 4 }}>
                          <Alert severity="error" sx={{ mb: 2 }}>
                          {abTestError}
                        </Alert>
                          <Button 
                            onClick={() => fetchAbTestData(selectedEmailId)}
                            variant="outlined"
                            size="small"
                          >
                            Réessayer
                          </Button>
                        </Box>
                      ) : !abTestData || !abTestData.variations || abTestData.variations.length < 2 ? (
                        <Alert severity="info">
                          Aucun test A/B significatif trouvé pour cet email.
                        </Alert>
                      ) : (
                        (() => {
                          const winner = abTestData.winner;
                          const criteria = abTestData.criteria || 'email.openrate';
                          
                          // Trouver le variant avec le score le plus bas selon les critères définis
                          const loser = abTestData.variations
                            .filter(v => v.id !== winner?.id)
                            .reduce((prev, current) => {
                              let prevScore, currentScore;
                              
                              switch (criteria) {
                                case 'email.clickrate':
                                  prevScore = prev.stats?.clickrate || prev.clickrate || 0;
                                  currentScore = current.stats?.clickrate || current.clickrate || 0;
                                  break;
                                case 'email.downloads':
                                  prevScore = prev.stats?.downloads || prev.downloads || 0;
                                  currentScore = current.stats?.downloads || current.downloads || 0;
                                  break;
                                case 'email.submissions':
                                  prevScore = prev.stats?.submissions || prev.submissions || 0;
                                  currentScore = current.stats?.submissions || current.submissions || 0;
                                  break;
                                case 'email.conversion':
                                  prevScore = (prev.stats?.openrate || prev.openrate || 0) + (prev.stats?.clickrate || prev.clickrate || 0) * 2 + (prev.stats?.downloads || prev.downloads || 0) * 1.5 + (prev.stats?.submissions || prev.submissions || 0) * 3;
                                  currentScore = (current.stats?.openrate || current.openrate || 0) + (current.stats?.clickrate || current.clickrate || 0) * 2 + (current.stats?.downloads || current.downloads || 0) * 1.5 + (current.stats?.submissions || current.submissions || 0) * 3;
                                  break;
                                case 'email.openrate':
                                default:
                                  prevScore = prev.stats?.openrate || prev.openrate || 0;
                                  currentScore = current.stats?.openrate || current.openrate || 0;
                                  break;
                              }
                              
                              return currentScore < prevScore ? current : prev;
                            }, abTestData.variations.find(v => v.id !== winner?.id));

                          const formatPercent = (value) => {
                            if (typeof value !== 'number' || isNaN(value)) return '0.0%';
                            return `${value.toFixed(1)}%`;
                          };

                          let openRateImprovement = null;
                          let clickRateImprovement = null;
                          let downloadsImprovement = null;
                          let submissionsImprovement = null;
                          let hasSignificantDifference = false;
                          let hasSufficientSample = false;
                          let minSampleSize = 0;
                          let significanceThreshold = 50;

                          if (winner && loser && winner.id !== loser.id) {
                            // Vérifier la taille d'échantillon minimum
                            const winnerSentCount = winner.stats?.sentCount || 0;
                            const loserSentCount = loser.stats?.sentCount || 0;
                            
                            // Vérifier que TOUTES les variantes ont au moins 1 envoi
                            const allVariantsHaveData = abTestData.variations.every(variation => 
                              (variation.stats?.sentCount || 0) >= 1
                            );
                            
                            hasSufficientSample = winnerSentCount >= 1 && loserSentCount >= 1 && allVariantsHaveData;
                            
                            const winnerOpenRate = winner.stats?.openrate ?? winner.openrate ?? 0;
                            const loserOpenRate = loser.stats?.openrate ?? loser.openrate ?? 0;
                            
                            const winnerClickRate = winner.stats?.clickrate ?? winner.clickrate ?? 0;
                            const loserClickRate = loser.stats?.clickrate ?? loser.clickrate ?? 0;
                            
                            const winnerDownloads = winner.stats?.downloads ?? winner.downloads ?? 0;
                            const loserDownloads = loser.stats?.downloads ?? loser.downloads ?? 0;
                            
                            const winnerSubmissions = winner.stats?.submissions ?? winner.submissions ?? 0;
                            const loserSubmissions = loser.stats?.submissions ?? loser.submissions ?? 0;
                            
                            openRateImprovement = calculateImprovement('openrate', winnerOpenRate, loserOpenRate);
                            clickRateImprovement = calculateImprovement('clickrate', winnerClickRate, loserClickRate);
                            downloadsImprovement = calculateImprovement('downloads', winnerDownloads, loserDownloads);
                            submissionsImprovement = calculateImprovement('submissions', winnerSubmissions, loserSubmissions);
                            
                            // Déterminer quelle métrique afficher selon le critère principal
                            let primaryMetricImprovement = null;
                            switch (criteria) {
                              case 'email.clickrate':
                                primaryMetricImprovement = clickRateImprovement;
                                break;
                              case 'email.downloads':
                                primaryMetricImprovement = downloadsImprovement;
                                break;
                              case 'email.submissions':
                                primaryMetricImprovement = submissionsImprovement;
                                break;
                              case 'email.conversion':
                                // Pour conversion, on peut montrer plusieurs métriques
                                primaryMetricImprovement = openRateImprovement; // ou un calcul composite
                                break;
                              case 'email.openrate':
                              default:
                                primaryMetricImprovement = openRateImprovement;
                                break;
                            }
                            
                            // Adapter le seuil de significativité selon la taille d'échantillon
                            minSampleSize = Math.min(winnerSentCount, loserSentCount);
                            if (minSampleSize >= 100) {
                              significanceThreshold = 5; // 5% pour échantillons larges
                            } else if (minSampleSize >= 10) {
                              significanceThreshold = 10; // 10% pour échantillons moyens
                            } else if (minSampleSize >= 5) {
                              significanceThreshold = 20; // 20% pour petits échantillons
                            } else {
                              significanceThreshold = 50; // 50% pour très petits échantillons
                            }
                            
                            // Vérifier s'il y a une différence significative selon le critère principal uniquement
                            hasSignificantDifference = primaryMetricImprovement && Math.abs(primaryMetricImprovement) >= significanceThreshold;
                          }

                          return (
                            <>
                              {/* Variantes */}
                              <Grid container spacing={3} sx={{ mb: 3 }}>
                                {abTestData.variations.map((variation, index) => {
                                  // Ne montrer un gagnant que si toutes les variantes ont des données suffisantes
                                  const isWinner = winner && variation.id === winner.id && hasSufficientSample;
                                  const isLoser = loser && variation.id === loser.id;
                                  const variantName = variation.name || `Variante ${String.fromCharCode(65 + index)}`;
                                  
                                  return (
                                    <Grid item xs={12} md={6} key={variation.id}>
                                      <Box sx={{
                                        p: 2.5,
                                        border: isWinner ? '2px solid #22C55E' : '1px solid #E5E7EB',
                                        bgcolor: isWinner ? '#F0FDF4' : 'white',
                                        borderRadius: 2,
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                      }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, overflow: 'hidden' }}>
                                          <Chip
                                            label={isWinner ? "GAGNANTE" : "VARIANTE"}
                                            size="small"
                                            sx={{
                                              bgcolor: isWinner ? '#22C55E' : '#6B7280',
                                              color: 'white',
                                              fontWeight: 700,
                                              fontSize: '0.7rem',
                                              height: '20px',
                                              letterSpacing: '0.5px',
                                              flexShrink: 0
                                            }}
                                          />
                                          <Typography 
                                            sx={{
                                              fontWeight: 600, 
                                              color: '#374151',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis'
                                            }}
                                            title={variantName}
                                          >
                                            {variantName}
                                          </Typography>
                                        </Box>
                                        <Typography sx={{ fontSize: '0.875rem', color: '#4B5563', mb: 2, flexGrow: 1 }}>
                                          Sujet: "{variation.subject || 'N/A'}"
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, fontSize: '0.875rem' }}>
                                          <Typography>
                                            Taux d'ouverture: 
                                            <Box component="span" sx={{ fontWeight: 'bold', color: isWinner ? '#16A34A' : '#1F2937' }}>
                                              {' '}{formatPercent(variation.stats?.openrate)}
                                            </Box>
                                          </Typography>
                                          <Typography>
                                            Taux de clics: 
                                            <Box component="span" sx={{ fontWeight: 'bold' }}>
                                              {' '}{formatPercent(variation.stats?.clickrate)}
                                            </Box>
                                          </Typography>
                                          <Typography>
                                            Envois: 
                                            <Box component="span" sx={{ fontWeight: 'bold' }}>
                                              {' '}{variation.stats?.sentCount || 0}
                                            </Box>
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Grid>
                                  );
                                })}
                              </Grid>

                              {/* Analyse statistique */}
                              {winner && loser && winner.id !== loser.id && (
                                <Box sx={{ p: 2, bgcolor: hasSignificantDifference ? '#EFF6FF' : '#FEF3C7', borderRadius: 2, border: hasSignificantDifference ? '1px solid #BEE3F8' : '1px solid #FDE68A' }}>
                                  <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', mb: 1, color: hasSignificantDifference ? '#1E40AF' : '#92400E' }}>
                                    {hasSignificantDifference ? 'Analyse statistique' : 'Résultats non significatifs'}
                                  </Typography>
                                  <Typography sx={{ fontSize: '0.875rem', color: '#1F2937' }}>
                                    {hasSignificantDifference ? (
                                      <>
                                        La variante <Box component="strong">{winner.name || 'gagnante'}</Box> performe mieux que <Box component="strong">{loser.name || 'la variante de contrôle'}</Box>
                                        {(() => {
                                          const criteria = abTestData.criteria || 'email.openrate';
                                          
                                          const getMetricInfo = (criteria) => {
                                            switch (criteria) {
                                              case 'email.clickrate': return { name: 'clics', improvement: clickRateImprovement };
                                              case 'email.downloads': return { name: 'téléchargements', improvement: downloadsImprovement };
                                              case 'email.submissions': return { name: 'soumissions', improvement: submissionsImprovement };
                                              case 'email.conversion': return { name: 'conversion globale', improvement: null }; // Score composite
                                              case 'email.openrate':
                                              default: return { name: 'ouverture', improvement: openRateImprovement };
                                            }
                                          };
                                          
                                          const primaryMetric = getMetricInfo(criteria);
                                          // Ne montrer que la métrique principale pour éviter la confusion
                                          const secondaryMetrics = [];
                                          
                                          return (
                                            <>
                                              {!hasSufficientSample && (
                                                <Alert severity="warning" sx={{ mb: 2, fontSize: '0.75rem' }}>
                                                  {(() => {
                                                    const variantsWithoutData = abTestData.variations.filter(v => (v.stats?.sentCount || 0) === 0);
                                                    if (variantsWithoutData.length > 0) {
                                                      return `Impossible de déterminer un gagnant : ${variantsWithoutData.length} variante${variantsWithoutData.length > 1 ? 's' : ''} sans envoi détecté. Toutes les variantes doivent avoir au moins 1 envoi.`;
                                                    }
                                                    return "Aucun envoi détecté pour au moins une variante. Impossible d'analyser les résultats.";
                                                  })()}
                                                </Alert>
                                              )}
                                              {hasSufficientSample && minSampleSize < 10 && (
                                                <Alert severity="info" sx={{ mb: 2, fontSize: '0.75rem' }}>
                                                  Échantillon très petit ({minSampleSize} envoi{minSampleSize > 1 ? 's' : ''} min.). Seuil de significativité adapté à {significanceThreshold}%. Les résultats sont indicatifs.
                                                </Alert>
                                              )}
                                              {primaryMetric.improvement !== null && Math.abs(primaryMetric.improvement) >= significanceThreshold && (
                                                <> selon le critère principal ({primaryMetric.name}) avec une <Box component="strong" sx={{ color: primaryMetric.improvement > 0 ? '#16A34A' : '#DC2626' }}>
                                                  {primaryMetric.improvement > 0 ? 'amélioration' : 'dégradation'} de {Math.abs(primaryMetric.improvement).toFixed(1)}%
                                                </Box></>
                                              )}
                                              {secondaryMetrics.length > 0 && (
                                                <>
                                                  {primaryMetric.improvement !== null && Math.abs(primaryMetric.improvement) >= significanceThreshold && secondaryMetrics.length > 0 && ' et '}
                                                  {secondaryMetrics.map((metric, index) => (
                                                    <Box key={metric.name} component="span">
                                                      {index > 0 && ', '}
                                                      <Box component="strong" sx={{ color: metric.improvement > 0 ? '#16A34A' : '#DC2626' }}>
                                                        {metric.improvement > 0 ? '+' : ''}{metric.improvement.toFixed(1)}% sur {metric.name}
                                                      </Box>
                                                    </Box>
                                                  ))}
                                                </>
                                              )}
                                            </>
                                          );
                                        })()}
                                        .
                                      </>
                                    ) : (
                                      <>
                                        Les différences entre les variantes sont trop faibles pour être statistiquement significatives.
                                        {!hasSufficientSample && ' De plus, certaines variantes n\'ont aucun envoi, empêchant toute comparaison fiable.'}
                                        {' '}Un échantillon plus large ou une durée de test plus longue pourrait être nécessaire.
                                      </>
                                    )}
                                  </Typography>
                                </Box>
                              )}
                            </>
                          );
                        })()
                      )}
                    </Paper>
                  </Box>
                )}

                {tabValue === getTabIndex('Configuration') && (
                  <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* Détails du Template */}
                    <Paper sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                        <SettingsIcon sx={{ color: '#6B7280' }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1F2937' }}>
                          Détails du Template
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', flexDirection: 'column', 'div:not(:last-of-type)': { borderBottom: '1px solid #F3F4F6' } }}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, py: 1.5 }}>
                          <Typography sx={{ fontSize: '0.875rem', color: '#4B5563' }}>Nom interne</Typography>
                          <Typography sx={{ fontSize: '0.875rem', color: '#1F2937', textAlign: 'right', fontFamily: 'monospace' }}>{selectedEmailDetails.name}</Typography>
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, py: 1.5 }}>
                          <Typography sx={{ fontSize: '0.875rem', color: '#4B5563' }}>Description</Typography>
                          <Typography sx={{ fontSize: '0.875rem', color: '#1F2937', textAlign: 'right' }}>{selectedEmailDetails.subject || 'N/A'}</Typography>
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, py: 1.5 }}>
                          <Typography sx={{ fontSize: '0.875rem', color: '#4B5563' }}>Date de création</Typography>
                          <Typography sx={{ fontSize: '0.875rem', color: '#1F2937', textAlign: 'right' }}>{new Date(selectedEmailDetails.dateAdded).toLocaleDateString('fr-FR')}</Typography>
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, py: 1.5 }}>
                          <Typography sx={{ fontSize: '0.875rem', color: '#4B5563' }}>Dernière modification</Typography>
                          <Typography sx={{ fontSize: '0.875rem', color: '#1F2937', textAlign: 'right' }}>{new Date(selectedEmailDetails.dateModified).toLocaleDateString('fr-FR')}</Typography>
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 2, py: 1.5 }}>
                          <Typography sx={{ fontSize: '0.875rem', color: '#4B5563' }}>Statut</Typography>
                          <Box sx={{ textAlign: 'right' }}>
                            <Chip 
                              label={selectedEmailDetails.isPublished ? 'Publié' : 'Brouillon'}
                              size="small" 
                              icon={<Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: selectedEmailDetails.isPublished ? '#16A34A' : '#F59E0B', ml: 1 }}/>}
                              sx={{ 
                                bgcolor: selectedEmailDetails.isPublished ? '#D1FAE5' : '#FEF3C7',
                                color: selectedEmailDetails.isPublished ? '#065F46' : '#92400E',
                                fontWeight: 500,
                                '& .MuiChip-icon': { mr: '-4px' }
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Paper>

                    {/* Utilisé dans les campagnes */}
                    <Paper sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                        <LinkIcon sx={{ color: '#6B7280' }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1F2937' }}>
                          Utilisé dans les campagnes
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {(() => {
                          const findEmailInEvents = (events, emailId) => {
                            if (!events || !Array.isArray(events)) return false;
                            for (const event of events) {
                              if (event.type === 'email.send' && event.properties?.email == emailId) {
                                return true;
                              }
                              if (event.children && event.children.length > 0) {
                                if (findEmailInEvents(event.children, emailId)) {
                                  return true;
                                }
                              }
                            }
                            return false;
                          };
                          
                          const associatedCampaigns = campaigns.filter(campaign => 
                            findEmailInEvents(campaign.events, selectedEmailDetails.id)
                          );
                          
                          if (associatedCampaigns.length > 0) {
                            return associatedCampaigns.map((campaign) => {
                              const status = getCampaignStatus(campaign);
                              return (
                                <Box 
                                  key={campaign.id} 
                                  sx={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between', 
                                    alignItems: 'center', 
                                    p: 2, 
                                    bgcolor: '#F9FAFB', 
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                    '&:hover': { bgcolor: '#F3F4F6' }
                                  }}
                                  onClick={() => navigate(`/campagne?id=${campaign.id}`)}
                                >
                                  <Box>
                                    <Typography sx={{ fontWeight: 500, color: '#2563EB', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>{campaign.name}</Typography>
                                    <Typography sx={{ fontSize: '0.75rem', color: '#6B7280' }}>ID: {campaign.id}</Typography>
                                  </Box>
                                  <Chip 
                                    label={status.label} 
                                    size="small" 
                                    sx={{
                                      bgcolor: status.bgColor,
                                      color: status.color,
                                      fontWeight: 500
                                    }}
                                  />
                                </Box>
                              );
                            });
                          } else {
                            return (
                              <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2, bgcolor: '#F9FAFB', borderRadius: 1 }}>
                                Ce template n'est utilisé dans aucune campagne.
                              </Typography>
                            );
                          }
                        })()}
                      </Box>
                    </Paper>
                  </Box>
                )}
              </Box>
            </>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#9CA3AF' }}>
              <Typography>Sélectionnez un email pour voir les détails</Typography>
            </Box>
          )}
          </Box>
        </Box>
      </Box>

      <Menu
        anchorEl={actionsMenuAnchor}
        open={Boolean(actionsMenuAnchor)}
        onClose={handleActionsMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            border: '1px solid #E5E7EB',
            borderRadius: 2,
            minWidth: 180
          }
        }}
      >
        <MenuItem onClick={() => { handleTogglePublishStatus(selectedEmailDetails.id, !selectedEmailDetails.isPublished); handleActionsMenuClose(); }} sx={{ gap: 1.5, py: 1.5, color: selectedEmailDetails?.isPublished ? '#059669' : '#374151' }}>
          {selectedEmailDetails?.isPublished ? <ToggleOnOutlinedIcon sx={{ fontSize: 16 }} /> : <ToggleOffOutlinedIcon sx={{ fontSize: 16 }} />}
          {selectedEmailDetails?.isPublished ? 'Désactiver' : 'Activer'}
        </MenuItem>
        <MenuItem onClick={() => { handleDuplicateClick(selectedEmailDetails); handleActionsMenuClose(); }} sx={{ gap: 1.5, py: 1.5, color: '#007B8A' }}>
          <ContentCopyIcon sx={{ fontSize: 16 }} /> Cloner
        </MenuItem>
        {isEmailArchived(selectedEmailDetails?.id) ? (
          <MenuItem 
            onClick={() => { 
              handleRestoreEmail(selectedEmailDetails?.id); 
              handleActionsMenuClose(); 
            }} 
            sx={{ gap: 1.5, py: 1.5, color: '#10B981' }}
          >
            <UnarchiveIcon sx={{ fontSize: 16 }} /> Restaurer
          </MenuItem>
        ) : (
          <MenuItem 
            onClick={() => { 
              handleArchiveEmail(selectedEmailDetails?.id); 
              handleActionsMenuClose(); 
            }} 
            sx={{ gap: 1.5, py: 1.5, color: '#D97706' }}
          >
            <ArchiveIcon sx={{ fontSize: 16 }} /> Archiver
          </MenuItem>
        )}
        <Tooltip title={isEmailInCampaign(selectedEmailDetails?.id) ? "Cet email est utilisé dans une campagne et ne peut pas être supprimé." : ""} arrow>
          <Box component="span" sx={{ display: 'block' }}>
            <MenuItem 
              onClick={() => { handleDeleteClick(selectedEmailDetails); handleActionsMenuClose(); }}
              sx={{ gap: 1.5, py: 1.5, color: 'error.main', width: '100%' }}
              disabled={isEmailInCampaign(selectedEmailDetails?.id)}
            >
              <DeleteIcon sx={{ fontSize: 16 }} /> Supprimer
            </MenuItem>
          </Box>
        </Tooltip>
      </Menu>

      <Menu
        anchorEl={statusMenuAnchor}
        open={Boolean(statusMenuAnchor)}
        onClose={handleStatusMenuClose}
      >
        <MenuItem onClick={() => { setStatusFilter('all'); handleStatusMenuClose(); }}>Tous</MenuItem>
        <MenuItem onClick={() => { setStatusFilter('published'); handleStatusMenuClose(); }}>Publié</MenuItem>
        <MenuItem onClick={() => { setStatusFilter('draft'); handleStatusMenuClose(); }}>Brouillon</MenuItem>
        <MenuItem onClick={() => { setStatusFilter('archived'); handleStatusMenuClose(); }}>Archivé</MenuItem>
      </Menu>

      <Menu
        anchorEl={sortMenuAnchor}
        open={Boolean(sortMenuAnchor)}
        onClose={handleSortMenuClose}
      >
        <MenuItem onClick={() => { setSortBy('modified'); handleSortMenuClose(); }}>Date de modification</MenuItem>
        <MenuItem onClick={() => { setSortBy('created'); handleSortMenuClose(); }}>Date de création</MenuItem>
        <MenuItem onClick={() => { setSortBy('name'); handleSortMenuClose(); }}>Nom (A-Z)</MenuItem>
      </Menu>

      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirmer la suppression"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Êtes-vous sûr de vouloir supprimer le template "{selectedEmail?.name}" ? Cette action est irréversible.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={isDeleting}>Annuler</Button>
          <Button onClick={handleConfirmDelete} color="error" autoFocus disabled={isDeleting}>
            {isDeleting ? <CircularProgress size={24} color="inherit" /> : 'Supprimer'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={renameModalOpen} onClose={handleCloseRenameModal} fullWidth maxWidth="sm">
        <DialogTitle>Dupliquer et renommer le template</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Entrez un nouveau nom pour le template dupliqué. Si vous laissez ce champ vide, un nom par défaut sera généré.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Nouveau nom du template (optionnel)"
            type="text"
            fullWidth
            variant="standard"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRenameModal} disabled={isCloning}>Annuler</Button>
          <Button onClick={handleConfirmClone} disabled={isCloning} variant="contained">
            {isCloning ? <CircularProgress size={24} color="inherit" /> : 'Confirmer la duplication'}
          </Button>
        </DialogActions>
      </Dialog>

      <Modal
        open={htmlModalOpen}
        onClose={handleCloseHtmlModal}
        aria-labelledby="html-code-modal-title"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 900,
          bgcolor: 'background.paper',
          border: '1px solid #ddd',
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '90vh',
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexShrink: 0 }}>
            <Typography id="html-code-modal-title" variant="h6" sx={{ color: '#1F2937' }}>
              Code HTML du Template
            </Typography>
            <IconButton onClick={handleCloseHtmlModal} sx={{ color: '#6B7280' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ flex: 1, overflow: 'auto', bgcolor: '#F9FAFB', p: 2, borderRadius: 1, border: '1px solid #E5E7EB' }}>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordWrap: 'break-word', fontSize: '0.875rem' }}>
              <code>
                {formattedHtml}
              </code>
            </pre>
          </Box>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
            <Button
              variant="contained"
              startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
              onClick={handleCopyHtml}
              sx={{
                textTransform: 'none',
                bgcolor: copied ? '#10B981' : '#007B8A',
                '&:hover': {
                  bgcolor: copied ? '#059669' : '#005f6b',
                },
                transition: 'background-color 0.3s ease',
              }}
            >
              {copied ? 'Copié dans le presse-papiers' : 'Copier le code'}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={textModalOpen}
        onClose={handleCloseTextModal}
        aria-labelledby="text-modal-title"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 900,
          bgcolor: 'background.paper',
          border: '1px solid #ddd',
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '90vh',
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexShrink: 0 }}>
            <Typography id="text-modal-title" variant="h6" sx={{ color: '#1F2937' }}>
              Version Texte du Template
            </Typography>
            <IconButton onClick={handleCloseTextModal} sx={{ color: '#6B7280' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ flex: 1, overflow: 'auto', bgcolor: '#F9FAFB', p: 2, borderRadius: 1, border: '1px solid #E5E7EB' }}>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordWrap: 'break-word', fontSize: '0.875rem', fontFamily: 'monospace' }}>
              {textContent || 'Aucune version texte disponible pour ce template.'}
            </pre>
          </Box>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
            <Button
              variant="contained"
              startIcon={textCopied ? <CheckIcon /> : <ContentCopyIcon />}
              onClick={handleCopyText}
              disabled={!textContent}
              sx={{
                textTransform: 'none',
                bgcolor: textCopied ? '#10B981' : '#007B8A',
                '&:hover': {
                  bgcolor: textCopied ? '#059669' : '#005f6b',
                },
                '&:disabled': {
                  bgcolor: '#9CA3AF',
                  color: '#6B7280',
                },
                transition: 'background-color 0.3s ease',
              }}
            >
              {textCopied ? 'Copié dans le presse-papiers' : 'Copier le texte'}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Spam Analysis Modal */}
      <Modal open={spamModalOpen} onClose={() => setSpamModalOpen(false)}>
        <Box sx={{ position: 'relative', backgroundColor: 'white', borderRadius: 2, p: 4, width: 'clamp(400px, 60vw, 800px)', margin: '5vh auto', outline: 'none', maxHeight: '90vh', overflowY: 'auto' }}>
          <IconButton
            aria-label="close"
            onClick={() => setSpamModalOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" gutterBottom>Analyse Anti-Spam</Typography>
          
          <Button 
            variant="contained" 
            onClick={handleAnalyze} 
            disabled={isAnalyzing || !spamFormData.from || !spamFormData.subject}
            startIcon={isAnalyzing ? <CircularProgress size={20} color="inherit" /> : <SecurityIcon />}
            fullWidth
            sx={{ my: 3 }}
          >
            {isAnalyzing ? 'Analyse en cours...' : 'Analyser'}
          </Button>

          {spamError && (
            <Box sx={{ mb: 2 }}>
            <Alert severity="error" sx={{ mb: 2 }}>
              {spamError}
            </Alert>
              <Box sx={{ textAlign: 'center' }}>
                <Button 
                  onClick={() => {
                    setSpamError(null);
                    if (spamError.includes('récupération')) {
                      // Retry loading latest report
                      openSpamModal();
                    } else {
                      // Retry analysis
                      handleAnalyze();
                    }
                  }}
                  variant="outlined"
                  size="small"
                >
                  Réessayer
                </Button>
              </Box>
            </Box>
          )}

          {/* Show message if no spam report is found and not loading */}
          {(!isSpamReportLoading && !spamReport) && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Aucune dernière analyse anti-spam trouvée. Cliquez sur le bouton 'Analyser' pour générer un rapport anti-spam.
            </Alert>
          )}

          {isSpamReportLoading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>Chargement du rapport anti-spam...</Typography>
            </Box>
          )}

          {spamReport && (
            <Box sx={{ borderTop: '1px solid #ddd', pt: 2 }}>
              {/* Métadonnées */}
              <Box mt={3}>
                <Typography variant="caption" color="text.secondary">
                  Analyse effectuée le : {spamReport.timestamp ? new Date(spamReport.timestamp).toLocaleString('fr-FR') : ''}
                </Typography>
              </Box>
              {/* Score global et verdict - NEW STYLE */}
              <Box mb={3} sx={{ textAlign: 'center', py: 2 }}>
                {/* Score circle with color */}
                <div
                  style={{
                    width: 150,
                    height: 150,
                    margin: '0 auto 20px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 52,
                    fontWeight: 'bold',
                    color: 'white',
                    boxShadow: '0 5px 15px rgba(0,0,0,0.15)',
                    backgroundColor:
                      spamReport.score >= 9
                        ? '#27ae60' // green
                        : spamReport.score >= 7
                        ? '#f39c12' // orange
                        : spamReport.score >= 4
                        ? '#d35400' // dark orange
                        : spamReport.score >= 2
                        ? '#c0392b' // red
                        : '#8e0e00', // dark red
                  }}
                >
                  {spamReport.score} <span style={{ fontSize: 28, fontWeight: 400, marginLeft: 6 }}>/ 10</span>
                </div>
                {/* Verdict title */}
                <div style={{ fontSize: 28, fontWeight: 700, margin: '10px 0 8px 0' }}>
                  {spamReport.verdict}
                </div>
                {/* Summary text */}
                <div style={{ maxWidth: 600, margin: '0 auto', color: '#555', fontSize: 18, lineHeight: 1.5 }}>
                  {spamReport.verdictDesc || spamReport.verdict_desc}
                </div>
              </Box>

              {/* LLM Report (detailed AI analysis) */}
              {spamReport.sections && spamReport.sections.length > 0 && (
                <Box>
                  {spamReport.sections.map((section, idx) => {
                    // Skip the "tech" section as requested
                    if (section.key === 'tech') return null;
                    
                    const isOpen = openSection === section.key;
                    // Extract the relevant part of the LLM report for this section
                    let sectionLLMReport = '';
                    const llmReportText = spamReport.llm_report || spamReport.llmReport || '';
                    const sectionHeaders = {
                      'auth': "1. Analyse de l'Authentification",
                      'reputation': '2. Analyse de la Réputation',
                      'content': '3. Analyse du Contenu et de la Sécurité',
                      'status': '4. Synthèse de l\'Analyse'
                    };
                    if (llmReportText && sectionHeaders[section.key]) {
                      const sectionHeader = sectionHeaders[section.key];
                      // Find the next section header (if any)
                      const headerKeys = Object.keys(sectionHeaders);
                      const currentIdx = headerKeys.indexOf(section.key);
                      let nextSectionHeader = null;
                      for (let i = currentIdx + 1; i < headerKeys.length; i++) {
                        if (sectionHeaders[headerKeys[i]]) {
                          nextSectionHeader = sectionHeaders[headerKeys[i]];
                          break;
                        }
                      }
                      let startIdx = llmReportText.indexOf(sectionHeader);
                      if (startIdx !== -1) {
                        startIdx = startIdx + sectionHeader.length;
                        let endIdx = nextSectionHeader ? llmReportText.indexOf(nextSectionHeader) : llmReportText.length;
                        if (endIdx !== -1 && endIdx > startIdx) {
                          sectionLLMReport = llmReportText.substring(startIdx, endIdx).trim();
                        } else {
                          sectionLLMReport = llmReportText.substring(startIdx).trim();
                        }
                      }
                    }
                    
                    // Determine the correct section number
                    let sectionNumber;
                    if (section.key === 'auth') sectionNumber = 1;
                    else if (section.key === 'reputation') sectionNumber = 2;
                    else if (section.key === 'content') sectionNumber = 3;
                    else if (section.key === 'status') sectionNumber = 4;
                    else sectionNumber = idx + 1;
                    
                    // Calculate section health status based on symbols
                    let healthStatus = "Excellent";
                    let healthStatusColor = "#388e3c"; // Green for excellent
                    let hasErrors = false;
                    let hasWarnings = false;
                    
                    // Check for issues in the section
                    if (section.details && section.details.length > 0 && section.key !== 'status') {
                      // Look for critical errors (high scores) and warnings (moderate scores)
                      for (const detail of section.details) {
                        if (detail.score > 1.5) {
                          hasErrors = true;
                          break;
                        } else if (detail.score > 0) {
                          hasWarnings = true;
                        }
                      }
                      
                      // Set status based on findings
                      if (hasErrors) {
                        healthStatus = "Problèmes Critiques";
                        healthStatusColor = "#d32f2f"; // Red
                      } else if (hasWarnings) {
                        healthStatus = "Améliorations Recommandées";
                        healthStatusColor = "#ed6c02"; // Orange/warning
                      }
                    }
                    
                    return (
                      <Box key={section.key} mb={3} sx={{ border: '1px solid #eee', borderRadius: 2, p: 0, background: '#f9f9fc' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            px: 2, py: 2,
                            borderRadius: 2,
                            background: isOpen ? '#e3f2fd' : 'inherit',
                            transition: 'background 0.2s',
                          }}
                          onClick={() => setOpenSection(isOpen ? null : section.key)}
                        >
                          <Typography variant="h6" sx={{ mb: 0, color: '#1976d2', fontWeight: 600 }}>
                            {(() => {
                              if (section.key === 'auth') return '1. ' + section.title;
                              if (section.key === 'reputation') return '2. ' + section.title;
                              if (section.key === 'content') return '3. ' + section.title;
                              if (section.key === 'status') return '4. ' + section.title;
                              return (idx + 1) + '. ' + section.title;
                            })()}
                          </Typography>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {section.key !== 'status' && (
                              <Typography variant="subtitle2" sx={{ 
                                mr: 2, 
                                fontWeight: 600, 
                                color: healthStatusColor 
                              }}>
                                {healthStatus}
                              </Typography>
                            )}
                            <span style={{ fontSize: 22 }}>{isOpen ? '▲' : '▼'}</span>
                          </div>
                        </Box>
                        <Collapse in={isOpen} timeout="auto" unmountOnExit>
                          <Box sx={{ px: 3, pb: 2, pt: 1 }}>
                            <Typography variant="body2" sx={{ mb: 1, color: '#555' }}>{section.desc}</Typography>
                            {/* Display the LLM report content for this section */}
                            {sectionLLMReport && (
                              <Box sx={{ mb: 2, p: 2, background: '#f8fafd', borderRadius: 2 }}>
                                <div style={{ whiteSpace: 'pre-line', color: '#222', fontSize: 16 }}>
                                  {/* Remove score references from LLM report */}
                                  {sectionLLMReport.replace(/\(score \d+\.\d+\)/g, '')}
                                </div>
                              </Box>
                            )}
                            {/* Only show symbol details if there are no LLM reports */}
                            {section.details && section.details.length > 0 ? (
                              <Box component="ul" sx={{ pl: 3, mb: 1 }}>
                                {section.details.map((d, i) => (
                                  <li key={d.symbol + i} style={{ marginBottom: 4 }}>
                                    <span style={{ fontWeight: 600 }}>{d.symbol}</span>
                                    {/* Removed score display here */}
                                    {d.description && <span style={{ marginLeft: 8, color: '#888' }}>— {d.description}</span>}
                                    {d.options && d.options.length > 0 && (
                                      <span style={{ marginLeft: 8, color: '#aaa', fontSize: 12 }}>({d.options.join(' ')})</span>
                                    )}
                                  </li>
                                ))}
                              </Box>
                            ) : (
                              <Typography variant="body2" color="text.secondary">Aucun symbole détecté dans cette section.</Typography>
                            )}
                          </Box>
                        </Collapse>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Modal>

      {/* Send Test Email Modal (Improved) */}
      <Dialog open={testEmailModalOpen} onClose={() => setTestEmailModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Envoyer un email de test</DialogTitle>
        <DialogContent dividers>
          {testEmailSuccess ? (
            <Alert severity="success" sx={{ mt: 2 }}>Email de test envoyé avec succès!</Alert>
          ) : (
            <Stack spacing={3} sx={{ mt: 1 }}>
              {testEmailError && <Alert severity="error">{testEmailError}</Alert>}
              
              <Box>
                <Typography variant="subtitle2" gutterBottom>Destinataires *</Typography>
                <Autocomplete
                  multiple
                  freeSolo
                  options={contactOptions}
                  loading={contactsLoading}
                  value={testRecipients}
                  inputValue={recipientInput}
                  getOptionLabel={(option) => {
                    if (typeof option === 'string') return option;
                    return `${option.properties.firstName || ''} ${option.properties.lastName || ''} <${option.properties.email}>`;
                  }}
                  onInputChange={(event, newInputValue) => {
                    setRecipientInput(newInputValue);
                    setContactInput(newInputValue);
                    debouncedSearchContacts(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    const processedValues = newValue.map(value => {
                      if (typeof value === 'string') {
                        return value;
                      } else if (value?.properties?.email) {
                        return value.properties.email;
                      }
                      return value;
                    });
                    setTestRecipients(processedValues);
                    if (testEmailError) setTestEmailError(null);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && recipientInput.trim()) {
                      e.preventDefault();
                      const emailToAdd = recipientInput.trim();
                      if (!isValidEmail(emailToAdd)) {
                        setTestEmailError('Format d\'email invalide.');
                        return;
                      }
                      if (testRecipients.includes(emailToAdd)) {
                        setTestEmailError('Cet email a déjà été ajouté.');
                        return;
                      }
                      setTestRecipients([...testRecipients, emailToAdd]);
                      setRecipientInput('');
                      setContactInput('');
                      setContactOptions([]);
                      setTestEmailError(null);
                    }
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={index}
                        label={option}
                        {...getTagProps({ index })}
                        color={isValidEmail(option) ? 'primary' : 'error'}
                        size="small"
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoFocus
                      label="Tapez un email ou recherchez un contact..."
                      placeholder={testRecipients.length === 0 ? "exemple@email.com ou nom du contact" : "Ajouter un autre destinataire..."}
                      variant="outlined"
                      error={testEmailError && testRecipients.length === 0}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {contactsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Box>

              <TextField
                label="Sujet de l'email de test"
                fullWidth
                value={testSubject}
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    backgroundColor: '#F9FAFB',
                    cursor: 'default'
                  }
                }}
              />
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ p: '16px 24px' }}>
          <Button 
            onClick={() => setTestEmailModalOpen(false)}
            disabled={isSendingTest}
          >
            Annuler
          </Button>
          {!testEmailSuccess && (
            <Button 
              onClick={handleSendTest} 
              variant="contained" 
              disabled={isSendingTest || testRecipients.length === 0 || testRecipients.some(email => !isValidEmail(email))}
              endIcon={isSendingTest ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
            >
              {isSendingTest ? 'Envoi en cours...' : 'Envoyer'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Modal de prévisualisation multi-clients */}
      <Modal open={mailPreviewModalOpen} onClose={() => setMailPreviewModalOpen(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ 
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 1200,
          height: '90vh',
          bgcolor: 'background.paper',
          border: '1px solid #ddd',
          boxShadow: 24,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 3, borderBottom: '1px solid #E5E7EB', flexShrink: 0 }}>
            <Typography variant="h6" sx={{ color: '#1F2937' }}>
              Aperçu Email on Acid
            </Typography>
            <IconButton onClick={() => setMailPreviewModalOpen(false)} sx={{ color: '#6B7280' }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
            {previewError && (
              <Box sx={{ mb: 2 }}>
              <Alert severity="error" sx={{ mb: 2 }}>
                {previewError}
              </Alert>
                <Box sx={{ textAlign: 'center' }}>
                  <Button 
                    onClick={() => {
                      setPreviewError(null);
                      sendForPreview();
                    }}
                    variant="outlined"
                    size="small"
                  >
                    Réessayer la prévisualisation
                  </Button>
                </Box>
              </Box>
            )}

            {(isPreviewLoading || isPolling) && (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <CircularProgress />
                <Typography sx={{ mt: 2 }}>
                  {isPolling ? `Génération des aperçus en cours... (Test ID: ${testId})` : 'Soumission du test...'}
                </Typography>
              </Box>
            )}

            {!isPreviewLoading && !isPolling && previewResults.length > 0 && (
              <Grid container spacing={2}>
                {previewResults.map((result) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={result.id}>
                    <Paper 
                      elevation={3} 
                      sx={{ cursor: 'pointer', '&:hover': { boxShadow: 6 } }} 
                      onClick={() => setSelectedClient(result)}
                    >
                      <Box sx={{ height: 200, overflow: 'hidden', borderTopLeftRadius: 4, borderTopRightRadius: 4 }}>
                        {result.status === 'Complete' && result.thumbnail_url ? (
                          <img src={result.thumbnail_url} alt={result.name} style={{ width: '100%', height: 'auto' }} />
                        ) : (
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                            <CircularProgress size={30} />
                            <Typography variant="caption" sx={{ mt: 1 }}>{result.status}...</Typography>
                          </Box>
                        )}
                      </Box>
                      <Typography variant="body2" sx={{ p: 1.5, textAlign: 'center', fontWeight: 'medium' }}>
                        {result.name}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </Box>
      </Modal>

      {/* Modal de vue agrandie pour un client sélectionné */}
      <Modal open={!!selectedClient} onClose={() => setSelectedClient(null)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ position: 'relative', outline: 'none' }}>
          <IconButton 
            onClick={() => setSelectedClient(null)} 
            sx={{ position: 'absolute', top: -40, right: -40, color: 'white', bgcolor: 'rgba(0,0,0,0.5)' }}
          >
            <CloseIcon />
          </IconButton>
          <img 
            src={selectedClient?.image_url} 
            alt={selectedClient?.name} 
            style={{ maxHeight: '90vh', maxWidth: '90vw' }} 
          />
        </Box>
      </Modal>

      {/* Email Assistant */}
      <EmailAssistant
        open={assistantOpen}
        onClose={() => {
          setAssistantOpen(false);
          setInterfaceHidden(false);
          setInitialMjml(null);
          setInitialBuilderJson(null);
          setInitialLastMode(null);
          setInitialHtmlEdited(false);
          setInitialHtmlSnapshot(null);
          setInitialDynamicContent(null);
          setEditorStateLoading(false);
          setEditorStateError(null);
        }}
        mode={assistantMode}
        email={selectedEmailDetails}
        initialMjml={initialMjml}
        initialBuilderJson={initialBuilderJson}
        initialLastMode={initialLastMode}
        initialHtmlEdited={initialHtmlEdited}
        initialHtmlSnapshot={initialHtmlSnapshot}
        editorStateLoading={editorStateLoading}
        editorStateError={editorStateError}
        onRetryEditorState={handleRetryEditorState}
        initialDynamicContent={initialDynamicContent}
        onContentChange={assistantMode === 'edit' ? ((newHtml) => {
          try {
            if (!selectedEmailDetails?.id) return;
            setEmails(prev => prev.map(e => (
              e.id === selectedEmailDetails.id
                ? { ...e, customHtml: newHtml }
                : e
            )));
          } catch (_) {}
        }) : undefined}
        onCreated={() => {
          try {
            // Clear selection and trigger immediate list refresh
            setSelectedEmailId(null);
            setPage(1);
            setRefreshKey((k) => k + 1);
          } catch (_) {}
          // Run heavier background refresh (A/B tests, campaigns) without delaying the email list
          try { fetchInitialData(); } catch (_) {}
        }}
      />

      {/* Contact Details Modal */}
      <Dialog
        open={contactDetailsOpen}
        onClose={() => {
          setContactDetailsOpen(false);
          setContactDetails(null);
          setSelectedContactId(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ borderBottom: '1px solid #E5E7EB', pb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Détails du contact
            </Typography>
            <IconButton 
              onClick={() => {
                setContactDetailsOpen(false);
                setContactDetails(null);
                setSelectedContactId(null);
              }}
              sx={{ color: '#6B7280' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 3 }}>
          {contactDetailsLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          ) : contactDetails ? (
            <Box>
              {/* Informations de base */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1F2937' }}>
                  Informations personnelles
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Prénom</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.first_name || 'Non renseigné'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Nom</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.last_name || 'Non renseigné'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Email</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.email || 'Non renseigné'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Téléphone</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.phone || 'Non renseigné'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Entreprise</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.company || 'Non renseigné'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Poste</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.position || 'Non renseigné'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Ville</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.city || 'Non renseigné'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Pays</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.country || 'Non renseigné'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Points</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.points}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>Dernière activité</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {contactDetails.contact.last_active ? new Date(contactDetails.contact.last_active).toLocaleDateString('fr-FR') : 'Non renseigné'}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              {/* Historique des emails */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1F2937' }}>
                  Historique des emails ({contactDetails.total_emails})
                </Typography>
                {contactDetails.email_history.length > 0 ? (
                  <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                    {contactDetails.email_history.map((email, index) => (
                      <Box key={index} sx={{ 
                        p: 2, 
                        border: '1px solid #E5E7EB', 
                        borderRadius: 1, 
                        mb: 1,
                        backgroundColor: '#F9FAFB'
                      }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {email.email_name || `Email ${email.email_id}`}
                          </Typography>
                          <Chip 
                            label={email.status}
                            size="small"
                            sx={{
                              fontSize: '0.75rem',
                              bgcolor: 
                                email.status === 'Ouvert' ? '#DEF7EC' :
                                email.status === 'Échec' ? '#FFE4E6' :
                                email.status === 'Non ouvert' ? '#FEF3C7' :
                                '#E0E7FF',
                              color: 
                                email.status === 'Ouvert' ? '#065F46' :
                                email.status === 'Échec' ? '#991B1B' :
                                email.status === 'Non ouvert' ? '#92400E' :
                                '#3730A3'
                            }}
                          />
                        </Box>
                        <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>
                          Envoyé le: {email.date_sent ? new Date(email.date_sent).toLocaleString('fr-FR') : 'Non renseigné'}
                        </Typography>
                        {email.date_read && (
                          <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>
                            Lu le: {new Date(email.date_read).toLocaleString('fr-FR')}
                          </Typography>
                        )}
                        {email.open_count > 0 && (
                          <Typography variant="body2" sx={{ color: '#6B7280' }}>
                            Ouvertures: {email.open_count}
                          </Typography>
                        )}
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2" sx={{ color: '#6B7280', fontStyle: 'italic' }}>
                    Aucun historique d'email disponible
                  </Typography>
                )}
              </Box>

              {/* Activités récentes */}
              <Box>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1F2937' }}>
                  Activités récentes ({contactDetails.total_activities})
                </Typography>
                {contactDetails.activities.length > 0 ? (
                  <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                    {contactDetails.activities.slice(0, 10).map((activity, index) => (
                      <Box key={index} sx={{ 
                        p: 2, 
                        border: '1px solid #E5E7EB', 
                        borderRadius: 1, 
                        mb: 1,
                        backgroundColor: '#F9FAFB'
                      }}>
                        <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                          {activity.name || activity.type}
                        </Typography>
                        {activity.description && (
                          <Typography variant="body2" sx={{ color: '#6B7280', mb: 0.5 }}>
                            {activity.description}
                          </Typography>
                        )}
                        <Typography variant="caption" sx={{ color: '#9CA3AF' }}>
                          {activity.date ? new Date(activity.date).toLocaleString('fr-FR') : 'Date non disponible'}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2" sx={{ color: '#6B7280', fontStyle: 'italic' }}>
                    Aucune activité récente disponible
                  </Typography>
                )}
              </Box>
            </Box>
          ) : (
            <Typography variant="body2" sx={{ color: '#6B7280', textAlign: 'center', py: 4 }}>
              Erreur lors du chargement des détails du contact
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Emails;

